import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import SequencerLibrary from "models/audioEditor/SequencerLibrary";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import SequencerNodeCloner from "models/audioEditor/sequencerNodes/SequencerNodeCloner";
import SequencerNode from "models/audioEditor/sequencerNodes/SequencerNode";
import AudioSequencerNode from "models/audioEditor/sequencerNodes/AudioSequencerNode";
import VideoSequencerNode from "models/audioEditor/sequencerNodes/VideoSequencerNode";
import DeletedSequencerNode from "models/audioEditor/sequencerNodes/DeletedSequencerNode";
import PauseSequencerNode from "models/audioEditor/sequencerNodes/PauseSequencerNode";
import PunctuationSequencerNode from "models/audioEditor/sequencerNodes/PunctuationSequencerNode";
import UnsupportedAudioSequencerNode from "models/audioEditor/sequencerNodes/UnsupportedAudioSequencerNode";
import WordSequencerNode from "models/audioEditor/sequencerNodes/WordSequencerNode";
import AudioEventSequencerNode from "models/audioEditor/sequencerNodes/AudioEventSequencerNode";
import StartMusicWrapSequencerNode from "models/audioEditor/sequencerNodes/StartMusicWrapSequencerNode";
import EndMusicWrapSequencerNode from "models/audioEditor/sequencerNodes/EndMusicWrapSequencerNode";
import SequencerRendererHelper from "models/audioEditor/SequencerRendererHelper";
import AudioBufferHelper from "models/audioEditor/AudioBufferHelper";
import SequencerSettings from "models/audioEditor/SequencerSettings";
import SequencerClipboard from "models/audioEditor/SequencerClipboard";
import SequencerSearchWidget from "models/audioEditor/SequencerSearchWidget";
import SequencerHistoryManagement from "models/audioEditor/SequencerHistoryManagement";
import DeleteSelectedNodesOperation from "models/audioEditor/sequencerOperation/DeleteSelectedNodesOperation";
import DeleteBulkSelectedNodesOperation from "models/audioEditor/sequencerOperation/DeleteBulkSelectedNodesOperation";
import RevertDeleteSelectedNodesOperation from "models/audioEditor/sequencerOperation/RevertDeleteSelectedNodesOperation";
import WrapSelectedNodesWithAudioOperation from "models/audioEditor/sequencerOperation/WrapSelectedNodesWithAudioOperation";
import DeleteWrapWithAudioNodesOperation from "models/audioEditor/sequencerOperation/DeleteWrapWithAudioNodesOperation";
import WrapSelectedNodesWithMuteOperation from "models/audioEditor/sequencerOperation/WrapSelectedNodesWithMuteOperation";
import DeleteWrapWithMuteNodesOperation from "models/audioEditor/sequencerOperation/DeleteWrapWithMuteNodesOperation";
import UpdateSequencerNodePropertyOperation from "models/audioEditor/sequencerOperation/UpdateSequencerNodePropertyOperation";
import MoveWrapNodesOperation from "models/audioEditor/sequencerOperation/MoveWrapNodesOperation";
import InsertAudioNodeOperation from "models/audioEditor/sequencerOperation/InsertAudioNodeOperation";
import InsertVideoNodeOperation  from "models/audioEditor/sequencerOperation/InsertVideoNodeOperation";
import DeleteAudioSequencerNodeOperation from "models/audioEditor/sequencerOperation/DeleteAudioSequencerNodeOperation";
import MoveNodeOperation from "models/audioEditor/sequencerOperation/MoveNodeOperation";
import TurnNoiseCancellationOnOperation from "models/audioEditor/sequencerOperation/TurnNoiseCancellationOnOperation";
import InsertNodeArrayOperation from "models/audioEditor/sequencerOperation/InsertNodeArrayOperation";
import CutAndCopyToClipboardOperation from "models/audioEditor/sequencerOperation/CutAndCopyToClipboardOperation";
import SequencerSettingsChangeOperation from "models/audioEditor/sequencerOperation/SequencerSettingsChangeOperation";
import LoadProjectOperation from "models/audioEditor/sequencerOperation/LoadProjectOperation";
import CorrectTranscriptOnSingleSequencerNodeOperation from "models/audioEditor/sequencerOperation/CorrectTranscriptOnSingleSequencerNodeOperation";
import RenameSpeakerNameSequencerOperation from "models/audioEditor/sequencerOperation/RenameSpeakerNameSequencerOperation";
import CreateNewSpeakerAndAssignToSequencerNodesOperation from "models/audioEditor/sequencerOperation/CreateNewSpeakerAndAssignToSequencerNodesOperation"
import ChangeSpeakerForParagraphOperation from "models/audioEditor/sequencerOperation/ChangeSpeakerForParagraphOperation";
import ChangeParagraphBoundaryPreferenceOperation from "models/audioEditor/sequencerOperation/ChangeParagraphBoundaryPreferenceOperation";
import TranscribeAndReplaceOperation from "models/audioEditor/sequencerOperation/TranscribeAndReplaceOperation";
import InsertAudioOrVideoNodesInBulkOperation from "models/audioEditor/sequencerOperation/InsertAudioOrVideoNodesInBulkOperation";
import DeleteSequencerNodeOperation from "models/audioEditor/sequencerOperation/DeleteSequencerNodeOperation";
import DeleteAllExceptSelectedNodesOperation from "models/audioEditor/sequencerOperation/DeleteAllExceptSelectedNodesOperation";
import RolloutHelper from "models/helper/FeatureRolloutHelper";
import UnknownSpeakerInfo from "models/audioEditor/UnknownSpeakerInfo";
import AudioBufferCache  from "models/audioEditor/AudioBufferCache";
import ti18n from "i18n!nls/Sequenceri18n";
import FileUploadHelper from "models/helper/FileUploadHelper";
import SequencerExportHelper from "models/audioEditor/SequencerExportHelper";
import RSVP from "rsvp";
import TurnMagicSoundEnhancerOnOperation from 'models/audioEditor/sequencerOperation/TurnMagicSoundEnhancerOnOperation';
import DisfluencyDetectorHelper from 'models/audioEditor/DisfluencyDetectorHelper';
import TrebbleAudio from 'models/TrebbleAudio';
import TrebbleNotificationManager from '../../components/common/NotificationManager';
import SequencerNodeFactory from "models/audioEditor/sequencerNodes/SequencerNodeFactory";
import { encode } from 'gpt-tokenizer';
import SequencerNodeUtils from 'models/audioEditor/SequencerNodeUtils';
import PersistentModels from "services/PersistentModels";
import AIEditSuggestionsProcessor from "models/audioEditor/AIEditSuggestionsProcessor";
import VoiceActivityDetectionManager from "models/audioEditor/VoiceActivityDetectionManager";
import FacebookEventTrackingHelper from "models/helper/FacebookEventTrackingHelper";
import AdditionCategoryConfig from "models/audioEditor/AdditionCategoryConfig";

const DO_NOT_SHOW_NON_EXPLICITELY_DISPLAYED_PAUSE = false;
const AUTO_SAVE_DELAY = 500;
const SAVE_PROJECT_RETRY_DELAYS_IN_MILLISECONDS = [1000, 3000, 5000];
const Rollout = RolloutHelper.getInstance();
const EDIT_VIDEO_FILES = Rollout.isFeatureEnabled(Rollout.FEATURES.EDIT_VIDEO_FILES, true);
const ID_GROUP_DELIMITER_FOR_LLM_MEDIA_TRANSCRIPTION = "|";
const DEFAULT_FILLER_WORDS = ["um", "uh", "uhm", "uhh", "umm", "uhs"];
const KEEP_BACKCHANNELING_WORDS = ["mmm", "mmhm", "mm-mm", "uh-uh", "uh-huh", "nuh-uh"];
const SAVE_PROJECT_WITHOUT_CLONING_NODES = false;
const Sequencer =  Backbone.Model.extend({
    
    model: SequencerNode,

    constructor: function(attributes, options) {
        Backbone.Model.apply(this, [attributes, options]);
        //this._audioUrlToTranscriptionAudioMap = {};
        this._firstNode = null;
        this._lastNode = null;
        this._hasMutationAccess = true;
        this._cidToSegmentNodeMap = {};
        this._collection =  new Backbone.Collection();
        this._historyManagement = new SequencerHistoryManagement({"sequencer": this});
        this.listenTo(this._historyManagement, "historyUpdated", this.onHistoryUpdated);
        this._deleteSelectedNodesOperation = new DeleteSelectedNodesOperation({"sequencer": this});
        this._deleteBulkSelectedNodesOperation = new DeleteBulkSelectedNodesOperation({"sequencer": this});
        this._revertDeleteSelectedNodesOperation = new RevertDeleteSelectedNodesOperation({"sequencer": this});
        this._wrapSelectedNodesWithAudioOperation = new WrapSelectedNodesWithAudioOperation({"sequencer": this});
        this._deleteWrapWithAudioNodesOperation =  new DeleteWrapWithAudioNodesOperation({"sequencer": this});
        this._wrapSelectedNodesWithMuteOperation = new WrapSelectedNodesWithMuteOperation({"sequencer": this});
        this._deleteWrapWithMuteNodesOperation = new DeleteWrapWithMuteNodesOperation({"sequencer": this});
        this._updateSequencerNodePropertyOperation = new UpdateSequencerNodePropertyOperation({"sequencer": this});
        this._moveWrapNodesOperation = new MoveWrapNodesOperation({"sequencer": this});
        this._insertAudioNodeOperation = new InsertAudioNodeOperation({"sequencer": this});
        this._insertVideoNodeOperation = new InsertVideoNodeOperation({"sequencer": this});
        this._deleteAudioSequencerNodeOperation = new DeleteAudioSequencerNodeOperation({"sequencer": this});
        this._moveNodeOperation = new MoveNodeOperation({"sequencer": this});
        this._loadProjectOperation = new LoadProjectOperation({"sequencer": this});
        this._turnNoiseCancellationOnOperation = new TurnNoiseCancellationOnOperation({"sequencer": this});
        this._turnMagicSoundEnhancerOnOperation = new TurnMagicSoundEnhancerOnOperation({"sequencer": this});
        this._insertNodeArrayOperation = new InsertNodeArrayOperation({"sequencer": this});
        this._cutAndCopyToClipboardOperation = new CutAndCopyToClipboardOperation({"sequencer": this});
        this._sequencerSettingsChangeOperation = new SequencerSettingsChangeOperation({"sequencer": this});
        this._sequencerSearchWidget = new SequencerSearchWidget({"sequencer": this});
        this._correctTranscriptOnSingleSequencerNodeOperation = new CorrectTranscriptOnSingleSequencerNodeOperation({"sequencer": this});
        this._renameSpeakerNameSequencerOperation = new RenameSpeakerNameSequencerOperation({"sequencer": this});
        this._createNewSpeakerAndAssignToSequencerNodesOperation = new CreateNewSpeakerAndAssignToSequencerNodesOperation({"sequencer": this});
        this._changeSpeakerForParagraphOperation = new ChangeSpeakerForParagraphOperation({"sequencer": this});
        this._changeParagraphBoundaryPreferenceOperation = new ChangeParagraphBoundaryPreferenceOperation({"sequencer": this});
        this._transcribeAndReplaceOperation = new TranscribeAndReplaceOperation({"sequencer": this});
        this._deleteSequencerNodeOperation = new DeleteSequencerNodeOperation({"sequencer": this});
        this._deleteAllExceptSelectedNodesOperation = new DeleteAllExceptSelectedNodesOperation({"sequencer": this});
        this._insertAudioOrVideoNodesInBulkOperation = new InsertAudioOrVideoNodesInBulkOperation({"sequencer": this, "insertAudioNodeOperation": this._insertAudioNodeOperation, "insertVideoNodeOperation": this._insertVideoNodeOperation});
        this._additionalSpeakerInfoArray = [];
        this._transcribeAudioArray = [];
        this._audioBufferCache =  new AudioBufferCache({sequencer: this});
        this._unknownSpeakerInfo = new UnknownSpeakerInfo();
        this.listenTo(this._correctTranscriptOnSingleSequencerNodeOperation, "transcriptionCorrection",(function(){
            this.trigger("transcriptionCorrection");
        }).bind(this))
        this.setAutoSaveOn(window.isWebAppInProduction() ?LocalStorageHelper.getInstance().isCurrentLoggedUserNotAVisitor(): false);
        this._projectId = null;
        this._warnedUserForFirstNoiseCancellation = false;
        this._warnedUserForFirstMagicSoundEnhancer = false;
        this._sequencerSettings = new SequencerSettings();
        this._sequencerSettings.setSequencer(this);
        this._sequencerClipboard = new SequencerClipboard();
        this._transcribedAudioFiles  = [];
        this._aiEditSuggestionsUrlForWhichCelebrationNotificationWasShown = [];
        this._workspaceId = undefined;
        this.setAutoScroll(true);
        this._listenToEventsOnCollection();
        this._listenToEventsFromSequencerRendererHelper();
        this._listenToChangeOnSequencerSettings();
        this._masterProcessingTurnedOn = false;
        this._analyzeAllMediaForSilencesHasProgressFunction = false;
        this.set("numberOfRenderingRequestPending", 0);
        this.set("isBeingSaved", false);
        this.set("mediaAnalysisProgress", 0);
        this.setFillerWords(DEFAULT_FILLER_WORDS)
        this._audioEditVersion = 0;
        this.setRerenderOnNextPlayback(true);
    },

    getMediaAnalysisProgress : function(){
        return this.get("mediaAnalysisProgress");
    },


    isEmpty :function(){

    },


    getId : function(){
        return this.cid;
    },

    getProjectTitle : function(){
        // Return a default project title for now
        // TODO: Add proper project title support in the future
        return "Trebble Project";
    },

    _listenToEventsOnCollection : function(){
        this.listenTo(this._collection, "add", this._onSequencerNodeAddedToSequencerNodeCollection.bind(this));
        this.listenTo(this._collection, "remove", this._onSequencerNodeRemovedFromSequencerNodeCollection.bind(this));
        this.listenTo(this._collection, "reset",  this._onSequencerNodeCollectionReset.bind(this));
    },

    _onSequencerNodeAddedToSequencerNodeCollection : function(modelAdded){
        this.trigger("add", modelAdded); 
        if(modelAdded.getAudioSegment().getHasVideo()){
            this.setHasVideoSegment(true);
            this.getSequencerSettings().setVideoResolution(modelAdded.getAudioSegment().getVideoWidth(), modelAdded.getAudioSegment().getVideoHeight(), true, true);
        }
    },

    _onSequencerNodeRemovedFromSequencerNodeCollection : function(modelRemoved){
        this.trigger("remove", modelRemoved);
    },

    _onSequencerNodeCollectionReset : function(modelRemoved){
        this.trigger("reset");
        this.setHasVideoSegment(false);
    },

    _listenToEventsFromSequencerRendererHelper : function(){
        this.listenTo(SequencerRendererHelper.getInstance(), "sequencerRenderingStarted", this.onAudioRenderingStarted);
        this.listenTo(SequencerRendererHelper.getInstance(), "sequencerRenderingCompleted", this.onAudioRenderingCompleted);
        this.listenTo(SequencerRendererHelper.getInstance(), "sequencerRenderingFailed", this.onAudioRenderingFailed);
    },

    _listenToChangeOnSequencerSettings : function(){
        this.listenTo(this._sequencerSettings, "changeWhichRequiresRerender", this.onSequencerSettingChangeWhichRequiresRerender);
    },	

    getUnknownSpeakerInfo : function(){
        return this._unknownSpeakerInfo;
    },

    getAudioBufferCache : function(){
        return this._audioBufferCache;
    },

    onSequencerSettingChangeWhichRequiresRerender : function(){
        this.setRerenderOnNextPlayback(true);
        return this.rerenderAndPlayIfApplicable();
    },

    getSequencerSettings : function(){
        return this._sequencerSettings;
    },

    getAdditionalSpeakerInforArray : function(){
        return this._additionalSpeakerInfoArray;
    },

    getSequencerClipboard : function(){
        return this._sequencerClipboard;
    },

    setRerenderOnNextPlayback: function(rerenderOnNextPlayback){
        if(rerenderOnNextPlayback && !this.get("rerenderOnNextPlayback")){
            this._audioEditVersion++;
        }
        this.set("rerenderOnNextPlayback", rerenderOnNextPlayback);
    },

    isRerenderRequiredOnNexPlayback: function(){
        return this.get("rerenderOnNextPlayback");
    },

    getAudioEditVersion: function(){
        return this._audioEditVersion;
    },

    setHasVideoSegment : function(hasVideoSegment){
        this.set("hasVideoSegment", hasVideoSegment);
    },

    getHasVideoSegment: function(){
        return this.get("hasVideoSegment");
    },

    isSpeakerWithLabelExist : function(speakerLabel){
        return !!this.getSpeakerWithLabel(speakerLabel);
    },

    getSpeakerInfoBySpeakerId : function(speakerId){
        for(let i =0; i < this._transcribeAudioArray.length; i++){
            const transcribedAudio = this._transcribeAudioArray[i];
            const speakerWithLabel= transcribedAudio.getSpeakerInfoWithId(speakerId);
            if(speakerWithLabel){
                return speakerWithLabel;
            }
        }

        for(let i =0; i < this._additionalSpeakerInfoArray.length; i++){
            const addidionalSpeakerInfo = this._additionalSpeakerInfoArray[i];
            if(addidionalSpeakerInfo.getSpeakerId() === speakerId){
                return addidionalSpeakerInfo;
            }
        } 
        return null;
    },

    getTotalNumberOfSpeakerInfo : function(){
        let totalNumberOfSpeaker = 0;
        totalNumberOfSpeaker = this._transcribeAudioArray.reduce((total, transcribeAudio)=>{
            if(transcribeAudio && transcribeAudio.getAllSpeakerInfo()){
                return total + transcribeAudio.getAllSpeakerInfo().length;
            }
            return total ;
        }, totalNumberOfSpeaker);

       if(this._additionalSpeakerInfoArray.length){
            totalNumberOfSpeaker =  totalNumberOfSpeaker + this._additionalSpeakerInfoArray.length;
       }
       return totalNumberOfSpeaker;
    },

    getSpeakerInfoIndex : function(speakerInfo){
        return this.getAllSpeakerInfo().indexOf(speakerInfo);
    },

    findWithAi : async function(){
        const result = await this._sequencerSearchWidget.applySemanticTextSearch();
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    displayAIEditSuggestionsByRequestId: async function(requestId){
        const result = await TrebbleClientAPIHelper.getInstance().getSuggestionResultUrlForRequestId(requestId);
        // Handle both old format (plain URL string) and new format (object with additionSuggestions)
        let aiSuggestionResultUrl = result;
        let additionSuggestions = null;
        if (result && typeof result === 'object' && result.resultFileUrl) {
            aiSuggestionResultUrl = result.resultFileUrl;
            var resultAdditionSuggestions = result.additionSuggestions || null;
            additionSuggestions = Array.isArray(resultAdditionSuggestions) ? resultAdditionSuggestions :
                (resultAdditionSuggestions && Array.isArray(resultAdditionSuggestions.additionSuggestions) ? resultAdditionSuggestions.additionSuggestions : null);
        }

        // The addition detector runs AFTER the deletion pipeline sends the webhook.
        // Only retry if this is the new object format — legacy plain-URL responses never
        // have additionSuggestions and should not be delayed.
        const isNewFormat = result && typeof result === 'object' && result.resultFileUrl;
        if (!additionSuggestions && aiSuggestionResultUrl && isNewFormat) {
            await new Promise(function(resolve) { setTimeout(resolve, 8000); });
            var retryResult = await TrebbleClientAPIHelper.getInstance().getSuggestionResultUrlForRequestId(requestId);
            var retryAdditionSuggestions = retryResult && typeof retryResult === 'object' ? retryResult.additionSuggestions : null;
            retryAdditionSuggestions = Array.isArray(retryAdditionSuggestions) ? retryAdditionSuggestions :
                (retryAdditionSuggestions && Array.isArray(retryAdditionSuggestions.additionSuggestions) ? retryAdditionSuggestions.additionSuggestions : null);
            if (retryAdditionSuggestions) {
                additionSuggestions = retryAdditionSuggestions;
            }
        }

        if(aiSuggestionResultUrl){
            // Store addition suggestions BEFORE calling displayAIEditSuggestions
            // so the processor can resolve their CIDs alongside deletions
            if (additionSuggestions && Array.isArray(additionSuggestions) && additionSuggestions.length > 0) {
                this._additionSuggestions = additionSuggestions;
                this._additionSuggestionsRequestId = requestId;
            } else {
                this._additionSuggestions = null;
                // Do NOT set _additionSuggestionsRequestId here — the Pusher path
                // (displayAIEditSuggestions) must still be allowed to refetch for this
                // requestId in case additions arrive after this URL-path fetch returns null.
            }
            await this.displayAIEditSuggestions(aiSuggestionResultUrl, requestId);
        }
    },

    /**
     * Apply an addition suggestion by inserting audio into the sequencer.
     * Called when the user clicks "Add to Edit" on an addition suggestion card.
     * Uses insertAudioNode for standalone audio (intro, outro, sound effects)
     * and wrapSelectedNodesWithMusic for background music.
     *
     * @param {Object} additionData - The addition suggestion data from the Lambda
     * @param {Object} anchorNode - The resolved sequencer node for insertion position
     */
    applyAdditionSuggestion: function(additionData, anchorNode) {
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            return false;
        }
        if (!additionData || !anchorNode) return false;

        var fileInfo = additionData.fileInfo || {};
        var trebbleAudio = new TrebbleAudio({
            audioId: fileInfo.audioId || (fileInfo.audioUrl + '_' + Date.now()),
            audioUrl: fileInfo.audioUrl || '',
            title: fileInfo.title || 'Untitled',
            artist: fileInfo.artist || '',
            audioType: fileInfo.audioType || additionData.type || 'sound_effect',
            isVideo: false,
            active: true
        });

        var type = (additionData.type || '').toLowerCase();

        // category is structural (insert vs wrap); background music must always wrap.
        var category = type === 'background_music' ? AdditionCategoryConfig.AdditionCategory.WRAP : additionData.category;
        var config = AdditionCategoryConfig.ADDITION_CATEGORY_CONFIG[category];
        if (!config) {
            category = AdditionCategoryConfig.AdditionCategory.INSERT;
            config = AdditionCategoryConfig.ADDITION_CATEGORY_CONFIG[category];
        }

        var params = AdditionCategoryConfig.validateAndMergeParams(config.transferableProps, config.defaultParams, additionData.params || {});
        var appliedResult = null;

        if (category === AdditionCategoryConfig.AdditionCategory.INSERT) {
            var insertedNode = this.insertAudioNode(
                trebbleAudio,
                anchorNode,
                params.insertBefore || additionData.resolvedInsertBefore || false,
                params.introPadding,
                params.outroPadding,
                params.introFade,
                params.outroFade,
                params.volume
            );
            appliedResult = insertedNode;
        } else if (category === AdditionCategoryConfig.AdditionCategory.WRAP) {
            var endNode = additionData.wrapEndAnchorNode || this.getLastNode();
            appliedResult = this.wrapSelectedNodesWithMusic(
                trebbleAudio,
                params.introPadding,
                params.outroPadding,
                params.introFade,
                params.outroFade,
                params.volume,
                params.loop,
                params.ducking,
                anchorNode,
                endNode
            );
        }

        if(!appliedResult){
            return false;
        }

        // Pre-load the audio buffer for smooth playback
        if (fileInfo.audioUrl) {
            this.getAudioBufferCache().loadAudioBufferFromUrl(
                fileInfo.audioUrl,
                fileInfo.audioUrl,
                AudioBufferHelper.getInstance().getAudioTypes().INSERT,
                this.getSequencerSettings()
            );
        }

        // Track analytics
        if (window.trebbleAnalyticsHelper) {
            window.trebbleAnalyticsHelper.trackEvent('sequencer', 'additionSuggestionApplied', 'addition suggestion applied', {
                type: type,
                positionType: additionData.positionType,
                confidence: additionData.confidence,
                fileTitle: fileInfo.title
            });
        }
        return appliedResult;
    },

    displayAIEditSuggestions : async function(aiSuggestionResultUrl, requestId){
        // Fetch additions if not already fetched for this requestId.
        // The backend fires ONE Pusher notification only after ADDITION_DETECTION_COMPLETED,
        // so additions are already in MongoDB when this runs.
        if (requestId && this._additionSuggestionsRequestId !== requestId) {
            try {
                var addResult = await TrebbleClientAPIHelper.getInstance().getSuggestionResultUrlForRequestId(requestId);
                var additions = (addResult && typeof addResult === 'object') ? addResult.additionSuggestions : null;
                additions = Array.isArray(additions) ? additions :
                    (additions && Array.isArray(additions.additionSuggestions) ? additions.additionSuggestions : null);
                const resolved = (additions && Array.isArray(additions) && additions.length > 0) ? additions : null;
                this._additionSuggestions = resolved;
                // Only lock the requestId when we successfully fetched additions.
                // If null (transient miss or detector still running), leave it unset so
                // a subsequent call for the same requestId can retry.
                if (resolved) {
                    this._additionSuggestionsRequestId = requestId;
                }
            } catch (err) {
                this._additionSuggestions = null;
                // Do not lock requestId on error — allow retry on next call.
            }
        }
        const result = await this._sequencerSearchWidget.applyAIEditSuggestions({searchQueryPresetsArray: Utils.getInstance().getDefaultSetOfAISearchQueryPresets()}, false, false, false, aiSuggestionResultUrl, requestId);
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    findDisfluencies : async function(){
        let notificationProgressUniqueId;
        try{
            if(this.areAllTranscribedFilesLoadedMatchingLanguage("en")){
            if(DisfluencyDetectorHelper.getInstance().isDisfluencyDetectionInProgress()){
                TrebbleNotificationManager.createWarningNotification(new Date().getTime().toString(), null, window.getI18n(ti18n, "DISFLUENCY_DETECTION_IN_PROGRESS_PLEASE_WAIT"), {  duration: 5,darkTheme: false, placement:"topRight" });
            }else{
                notificationProgressUniqueId = new Date().getTime().toString();
                TrebbleNotificationManager.createLoadingNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "ANALYZING_THE_TRANSCRIPT_FOR_DISFLUENCIES"),{ duration: 0 ,darkTheme: false,  placement:"topRight"});
                const disfluencySequencerNodeInfoArray = await DisfluencyDetectorHelper.getInstance().getDisluencySequencerNodes(this.getFirstNode(), this.getLastNode());
                if(!disfluencySequencerNodeInfoArray || disfluencySequencerNodeInfoArray.length === 0 ){
                    Utils.getInstance().showConfetti();
                    TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                    TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "RAS_LOOKS_LIKE_YOUR_FILE_IS_CLEAR"), {duration: 5, darkTheme: false, placement:"topRight" })
                    if(window.trebbleAnalyticsHelper){
                        window.trebbleAnalyticsHelper.trackEvent("sequencer", 'noDifluencyFound', 'No Disfluency found');
                    }
                }else{
                    const result = await this._sequencerSearchWidget.applyDisfluencySearch(disfluencySequencerNodeInfoArray);
                    if(result !== null){ // Only proceed if operation wasn't cancelled
                        if(window.trebbleAnalyticsHelper){
                            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'highlightDisfluencyFound', 'Highlight Disfluency Found');
                        }
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                        TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "YAY_WE_SPOTTED_SOME_DISFLUENCIES"), {duration: 5, darkTheme: false, placement:"topRight" })
                        this.setSearchOn(true);
                    } else {
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                    }
                }
            }
        }else{
            Utils.getInstance().showSorryMessage(window.getI18n(ti18n,"CLARITY_SPARK_ONLY_AVAILABLE_IN_ENGLISH"),window.getI18n(ti18n,"OUR_TEAM_IS_DEDICATED_TO_ADD_MORE_LANGUAGE_TO_CLARITY_SPARK"))
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'disfluencySearchNotAvailableInThisLanguage', 'Disfluency search not available in this lanuguage');
            }
        }
        }catch(error){
            if(!notificationProgressUniqueId){
                notificationProgressUniqueId =new Date().getTime().toString();
            }
            TrebbleNotificationManager.createErrorNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "ERROR_WHILE_DETECTING_DISFLUENCIES"), { duration: 5,darkTheme: false, placement:"topRight" })
        }
    },

    findFillerWords : async function(){
        const result = await this._sequencerSearchWidget.applyFillerWordsSearch();
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    findEditBoundaries : async function(){
        const result = await this._sequencerSearchWidget.applyEditBoundariesSearch();
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    doesMediaNeedToBeAnalyzedForSilences : function(){
        for(let i = 0; i < this.getAllTranscriptionMediaUrls().length; i++){
            const mediaUrl = this.getAllTranscriptionMediaUrls()[i];
            // Check for BALANCED config (unified approach across all use cases)
            if(!this.getAudioBufferCache().isVoiceActivityDataAvailableForAudioUrl(mediaUrl, VoiceActivityDetectionManager.VAD_CONFIGS.BALANCED)){
                return true;
            }
        }
        return false;
    },

    analyzeAllMediaForSilences : async function(onAnalysisPogressFunction){
        // If analysis is already in progress, handle accordingly
        if (this._analyzeAllMediaForSilencesPromise) {
            return this._handleOngoingAnalysis(onAnalysisPogressFunction);
        }

        // Start new analysis
        return this._startNewMediaAnalysis(onAnalysisPogressFunction);
    },

    _handleOngoingAnalysis: async function(onAnalysisPogressFunction) {
        // If no progress function needed, just return existing promise
        if (!onAnalysisPogressFunction || this._analyzeAllMediaForSilencesHasProgressFunction) {
            return this._analyzeAllMediaForSilencesPromise;
        }

        // Need to show progress for a function that came after one without progress
        const defaultProgressMessage = window.getI18n(ti18n, "ANALYZING_MEDIA");
        const actionToExecute = this._createProgressWrapperAction(defaultProgressMessage);
        
        await onAnalysisPogressFunction(actionToExecute, defaultProgressMessage);
        return this._analyzeAllMediaForSilencesPromise;
    },

    _createProgressWrapperAction: function(defaultProgressMessage) {
        return (async function(progressReportFunction){
            if (!progressReportFunction) {
                await this._analyzeAllMediaForSilencesPromise;
                return;
            }

            // Set up progress monitoring
            const onProgressUpdate = () => {
                const currentProgress = this.getMediaAnalysisProgress();
                progressReportFunction(currentProgress, defaultProgressMessage);
            };
            
            this.on("change:mediaAnalysisProgress", onProgressUpdate);
            onProgressUpdate(); // Send initial progress
            
            try {
                await this._analyzeAllMediaForSilencesPromise;
            } finally {
                this.off("change:mediaAnalysisProgress", onProgressUpdate);
            }
        }).bind(this);
    },

    _startNewMediaAnalysis: async function(onAnalysisPogressFunction) {
        this._analyzeAllMediaForSilencesHasProgressFunction = !!onAnalysisPogressFunction;

        this._analyzeAllMediaForSilencesPromise = this._executeMediaAnalysis(onAnalysisPogressFunction);
        
        // Clean up when done
        this._analyzeAllMediaForSilencesPromise
            .then(() => this._clearAnalysisState())
            .catch(() => this._clearAnalysisState());

        return this._analyzeAllMediaForSilencesPromise;
    },

    _executeMediaAnalysis: async function(onAnalysisPogressFunction) {
        const defaultProgressMessage = window.getI18n(ti18n, "ANALYZING_MEDIA");
        const actionToExecute = this._createAnalysisAction(defaultProgressMessage);
        
        if (onAnalysisPogressFunction) {
            await onAnalysisPogressFunction(actionToExecute, defaultProgressMessage);
        } else {
            await actionToExecute();
        }
    },

    _createAnalysisAction: function(defaultProgressMessage) {
        return (async function(progressReportFunction){
            const mediaUrls = this.getAllTranscriptionMediaUrls();
            const totalNumberOfMedia = mediaUrls.length;
            
            await Promise.all(mediaUrls.map(async (mediaUrl, index) => {
                // Check for BALANCED config (unified approach across all use cases)
                if (this.getAudioBufferCache().isVoiceActivityDataAvailableForAudioUrl(mediaUrl, VoiceActivityDetectionManager.VAD_CONFIGS.BALANCED)) {
                    return; // Skip if already analyzed
                }

                const onProgressReported = (currentMediaProgress) => {
                    const progress = ((currentMediaProgress + (index * 100)) / (totalNumberOfMedia * 100)) * 100;
                    this.set("mediaAnalysisProgress", progress);
                    if (progressReportFunction) {
                        progressReportFunction(progress, defaultProgressMessage);
                    }
                };

                const voiceActivityData = await this.getAudioBufferCache().loadVoiceActivityDataForAudioUrl(
                    mediaUrl, 
                    mediaUrl, 
                    AudioBufferHelper.getInstance().getAudioTypes().VOICE, 
                    this.getSequencerSettings(),
                    VoiceActivityDetectionManager.VAD_CONFIGS.BALANCED, // Use unified balanced config for all use cases
                    onProgressReported
                );
                if (voiceActivityData === null) {
                    return;
                }
            }));
        }).bind(this);
    },

    _clearAnalysisState: function() {
        this._analyzeAllMediaForSilencesPromise = null;
        this._analyzeAllMediaForSilencesHasProgressFunction = false;
    },

    findSilences : async function(maxSilenceInMilliseconds ){
        const result = await this._sequencerSearchWidget.applySearchResultsForSilencesToTrim(maxSilenceInMilliseconds);
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    removeAdditionalSpeakerBySpeakerLabel: function(speakerLabel){
      let indexOfSpeakerInfoToRemove = -1;
      for(let i=0; i < this._additionalSpeakerInfoArray.length; i++){
          const addidionalSpeakerInfo = this._additionalSpeakerInfoArray[i];
          if(addidionalSpeakerInfo.getSpeakerLabel() === speakerLabel){
            indexOfSpeakerInfoToRemove = i;
            break;
          }
      }  
      if(indexOfSpeakerInfoToRemove > -1){
        this._additionalSpeakerInfoArray.splice(indexOfSpeakerInfoToRemove, 1);
      }
    },

    removeAdditionalSpeakerBySpeakerId: function(speakerId){
      let indexOfSpeakerInfoToRemove = -1;
      for(let i=0; i < this._additionalSpeakerInfoArray.length; i++){
          const addidionalSpeakerInfo = this._additionalSpeakerInfoArray[i];
          if(addidionalSpeakerInfo.getSpeakerId() === speakerId){
            indexOfSpeakerInfoToRemove = i;
            break;
          }
      }
      if(indexOfSpeakerInfoToRemove > -1){
        this._additionalSpeakerInfoArray.splice(indexOfSpeakerInfoToRemove, 1);
      }
    },

    generateSpeakerLabelIfDuplicate: function(speakerId,speakerLabel){
        const numberOfSpeakerWithSameLabel = this.getNumberOfSpeakersWithSameLabelButDifferentId(speakerId, speakerLabel);
        if(numberOfSpeakerWithSameLabel > 0){
            //const totalNumberOfSpeakers = this.getTotalNumberOfSpeakerInfo();
            let speakerIndex = 1;
            let newSpeakerLabel =`${window.getI18n(ti18n, "SPEAKER")} ${speakerIndex}`
            while(this.getNumberOfSpeakersWithSameLabelButDifferentId(speakerId, newSpeakerLabel) > 0){
                speakerIndex = speakerIndex + 1;
                newSpeakerLabel = `${window.getI18n(ti18n, "SPEAKER")} ${speakerIndex}`;
            }
            return newSpeakerLabel;
        }
        return speakerLabel;
    },

    getNumberOfSpeakersWithSameLabelButDifferentId : function(speakerId, speakerLabel){
        let numberOfSpeakerWithSameLabelButDifferentId = 0;
        const uniqueSpeakerIds = [];
        for(let i =0; i < this._transcribeAudioArray.length; i++){
            const transcribedAudio = this._transcribeAudioArray[i];
            const speakerWithLabel= transcribedAudio.getSpeakerInfoWithLabel(speakerLabel);
            if(speakerWithLabel && speakerWithLabel.getSpeakerId() !== speakerId && !uniqueSpeakerIds.includes(speakerWithLabel.getSpeakerId())){
                uniqueSpeakerIds.push(speakerWithLabel.getSpeakerId());
                numberOfSpeakerWithSameLabelButDifferentId = numberOfSpeakerWithSameLabelButDifferentId + 1;
            }
        }

        for(let i =0; i < this._additionalSpeakerInfoArray.length; i++){
            const addidionalSpeakerInfo = this._additionalSpeakerInfoArray[i];
            if(addidionalSpeakerInfo.getSpeakerLabel() === speakerLabel){
                if(addidionalSpeakerInfo.getSpeakerId() !== speakerId && !uniqueSpeakerIds.includes(addidionalSpeakerInfo.getSpeakerId())){
                    uniqueSpeakerIds.push(addidionalSpeakerInfo.getSpeakerId());
                    numberOfSpeakerWithSameLabelButDifferentId = numberOfSpeakerWithSameLabelButDifferentId + 1;
                }
            }
        } 
        return numberOfSpeakerWithSameLabelButDifferentId;
    },

    getSpeakerWithLabel : function(speakerLabel){
        for(let i =0; i < this._transcribeAudioArray.length; i++){
            const transcribedAudio = this._transcribeAudioArray[i];
            const speakerWithLabel= transcribedAudio.getSpeakerInfoWithLabel(speakerLabel);
            if(speakerWithLabel){
                return speakerWithLabel;
            }
        }

        for(let i =0; i < this._additionalSpeakerInfoArray.length; i++){
            const addidionalSpeakerInfo = this._additionalSpeakerInfoArray[i];
            if(addidionalSpeakerInfo.getSpeakerLabel() === speakerLabel){
                return addidionalSpeakerInfo;
            }
        } 
        return null;
    },

    getAllSpeakerInfo : function(){
        let allSpeakerInfo = [];
        this._transcribeAudioArray.map((transcribedAudio)=>{
            allSpeakerInfo = allSpeakerInfo.concat(transcribedAudio.getAllSpeakerInfo())
        });
        this._additionalSpeakerInfoArray.map((additionalSpeakerInfo)=>{
            allSpeakerInfo.push(additionalSpeakerInfo);
        })
        return allSpeakerInfo;
    },

    createAdditionalSpeakerInfoWithLabel : function(speakerLabel){
        const newSpeakerInfo  = Utils.getInstance().getSpeakerInfo("speakerId"+Utils.getInstance().generateRandomId(), speakerLabel);
        this.addAdditionalSpeakerInfo(newSpeakerInfo);
        return newSpeakerInfo;
    },

    addAdditionalSpeakerInfo : function(additionalSpeakerInfo){
        const speakerId = additionalSpeakerInfo && additionalSpeakerInfo.getSpeakerId ? additionalSpeakerInfo.getSpeakerId() : null;
        const existingSpeakerInfo = speakerId ? this.getSpeakerInfoBySpeakerId(speakerId) : null;
        if(existingSpeakerInfo){
            return existingSpeakerInfo;
        }
        if(additionalSpeakerInfo){
            this._additionalSpeakerInfoArray.push(additionalSpeakerInfo);
        }
        return additionalSpeakerInfo;
    },

    createAdditionalSpeakerInfoFromSerializedData : function(serializedData) {
        return this.addAdditionalSpeakerInfo(Utils.getInstance().createSpeakerInfoFromSerializedData(serializedData));
    },

    getNumberOfRenderingRequestPending: function(){
        if(this.get("numberOfRenderingRequestPending") > 0){
            return this.get("numberOfRenderingRequestPending");
        }else{
            return 0;
        }
    },

    setFillerWords : function(arrayOfFillerWords){
        this.set("arrayOfFillerWords",arrayOfFillerWords);
    },

    getFillerWords : function(){
        return this.get("arrayOfFillerWords");
    },

    deleteAllFillerWords : function(){
        if(!this.hasMutationAccess()){
            return 0;
        }
        const searchResults = this.getSearchWidget().getSearhResultsForFillerWords();
        this._deleteBulkSelectedNodesOperation.execute(searchResults.allArraysOfNodesToHiglights.map((function(arrayOfNodeToDelete){
            return [arrayOfNodeToDelete[0], arrayOfNodeToDelete[arrayOfNodeToDelete.length - 1]];
        }).bind(this)));
        return searchResults.allArraysOfNodesMatchingResults && searchResults.allArraysOfNodesMatchingResults.length;
    },

    trimSilences : function(maxSilenceInMilliseconds){
        if(!this.hasMutationAccess()){
            return 0;
        }
        const searchResults = this.getSearchWidget().getSearchResultsForSilencesToTrim(maxSilenceInMilliseconds);
        this._deleteBulkSelectedNodesOperation.execute(searchResults.allArraysOfNodesToHiglights.map((function(arrayOfNodeToDelete){
            return [arrayOfNodeToDelete[0], arrayOfNodeToDelete[arrayOfNodeToDelete.length - 1]];
        }).bind(this)));
        return searchResults.allArraysOfNodesMatchingResults && searchResults.allArraysOfNodesMatchingResults.length;
    },

    deleteAllSearchResults : function(){
        if(!this.hasMutationAccess()){
            return 0;
        }
        const searchWidget = this.getSearchWidget();
        const allArraysOfNodesMatchingResults =  searchWidget.getAllArraysOfNodesMatchingResults();
        const allArraysOfNodesToHiglights =  searchWidget.getAllArraysOfNodesToHiglights();
        const allArraysOfAdditionalMatchingResults =  searchWidget.getAllArraysOfAdditionalMatchingResults();
        const createDeletionSourceFunction = searchWidget.createDeletionSourceFromResult.bind(searchWidget);
        // Filter out addition suggestions — they should not be bulk-deleted
        const bulkDeletionResult = this._deleteBulkSelectedNodesOperation.execute(allArraysOfNodesToHiglights.map((function(arrayOfNodeToDelete, index){
            const additionalMatchingResult  = index < allArraysOfAdditionalMatchingResults?.length ? allArraysOfAdditionalMatchingResults[index]: null;
            if (additionalMatchingResult && additionalMatchingResult.isAddition) return null;
            return [arrayOfNodeToDelete[0], arrayOfNodeToDelete[arrayOfNodeToDelete.length - 1],  createDeletionSourceFunction(null, true, additionalMatchingResult)];
        }).bind(this)).filter(Boolean));
        const numberOfResultsDeleted =  allArraysOfNodesToHiglights && allArraysOfNodesToHiglights.filter(function(_, i) { return !(allArraysOfAdditionalMatchingResults?.[i]?.isAddition); }).length;
        TrebbleNotificationManager.createSuccessNotification(new Date().getTime().toString(), null,numberOfResultsDeleted +" " + window.getI18n(ti18n, "RESULTS_DELETED"), {duration: 3, darkTheme: false, placement:"topRight" })
        if(window.trebbleAnalyticsHelper){
            const analyticsParams = {searchType : searchWidget.getSearchType(), numberOfResultsDeleted};
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'deleleBulkSearchResults', 'Delete bulk search results for search type '+ searchWidget.getSearchType(), null, analyticsParams);
        }
        this.clearSearch();
        searchWidget.recordAppliedSuggestionFeedbackForBulkDeletionResult(bulkDeletionResult);
        return numberOfResultsDeleted;
    },




    isTherePendingRenderingRequest : function(sequencer){
        return this.getNumberOfRenderingRequestPending() > 0;
    },

    increaseNumberOfRenderingRequestPending: function(sequencer){
        this.set("numberOfRenderingRequestPending", this.getNumberOfRenderingRequestPending()+ 1);
    },

    decreaseNumberOfRenderingRequestPending: function(sequencer){
        this.set("numberOfRenderingRequestPending", this.getNumberOfRenderingRequestPending() - 1);
    },

    setAutoSaveOn : function(autoSaveOn){
        this.set("autoSaveOn", autoSaveOn);
    },

    setMutationAccess : function(hasMutationAccess){
        this._hasMutationAccess = hasMutationAccess !== false;
        if(!this.hasMutationAccess() && this._pendingProductSave){
            clearTimeout(this._pendingProductSave);
            this._pendingProductSave = null;
            this.set("isBeingSaved", false);
        }
    },

    hasMutationAccess : function(){
        return this._hasMutationAccess !== false;
    },

    getAutoSaveOn : function(){
        return this.get("autoSaveOn") && this.hasMutationAccess();
    },

    setVideoContext : function(videoContext){
        this._videoContext = videoContext;
    },

    getVideoContext : function(){
        return this._videoContext;
    },

    setModernVideoRenderer : function(renderer){
        this._modernVideoRenderer = renderer;
    },

    getModernVideoRenderer : function(){
        return this._modernVideoRenderer;
    },

    /**
     * Get the active video renderer (VideoContext or modern renderer) based on feature flag
     * Returns the appropriate renderer for playback operations
     * @returns {Object|null} VideoContext instance or modern video renderer, or null if no video
     */
    getActiveVideoRenderer : function(){
        /* global USE_TIMELOOM_RENDERER */
        if (!this.getHasVideoSegment()) {
            return null;
        }

        // Check feature flag to determine which renderer to use
        // Use typeof check to prevent ReferenceError if flag is not defined
        if (typeof USE_TIMELOOM_RENDERER !== 'undefined' && USE_TIMELOOM_RENDERER) {
            return this.getModernVideoRenderer() || this.getVideoContext();
        } else {
            return this.getVideoContext() || null;
        }
    },

    setAutoScroll : function(autoscroll, silent){
        //this.set("autoscroll", autoscroll);
        this._sequencerSettings.setAutoscroll(autoscroll, silent);
    },

    getAutoScroll : function(){
        //return this.get("autoscroll");
        return this._sequencerSettings.isAutoscroll();
    },

    onHistoryUpdated : function(operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate){
        this.trigger("historyUpdated", operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate);
        this.setRerenderOnNextPlayback(true);
        if(this.getAutoSaveOn()){
            this.scheduleProjectSave(operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate);
        }
        return this.rerenderAndPlayIfApplicable();
    },

    scheduleProjectSave:function(operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate){
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            return RSVP.Promise.resolve();
        }
        this.set("isBeingSaved", true);
        if(this._pendingProductSave){
            clearTimeout(this._pendingProductSave);
        }
        const saveProjectDeferred = (function(){
            const saveProjectPromise = this.saveProject(null, operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate);
            if(saveProjectPromise && typeof saveProjectPromise.catch === "function"){
                saveProjectPromise.catch(function(error){
                    console.warn("Background project save failed:", error);
                });
            }
        }).bind(this);
        this._pendingProductSave = setTimeout(saveProjectDeferred,AUTO_SAVE_DELAY);
    },

    saveProject: function(force, operationNameWhichTriggerHistoryUpdate, operationLogWhichTriggerHistoryUpdate, createNewProjectId){
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            this.set("isBeingSaved", false);
            return RSVP.Promise.resolve();
        }
        this.trigger("projectBeingSaved");
        this.set("isBeingSaved", true);
        const serializedData = this.getSerializedData();
        if(!serializedData){
            if(!this.isSequencerPossiblyCleared()){
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("sequencer", 'FailedSavingSequencerProject', 'serializedData was null');
                }
                window.sendErrorToRaygun('serializedData was null', true);
            }
            this.trigger("projectFailedToBeSaved");
            this.set("isBeingSaved", false);
            return RSVP.Promise.resolve();
        }


        const simplifiedSerializedData = {"textTranscription": serializedData.textTranscription,
        "sequencerSettings" : serializedData.sequencerSettings,
        "transcribedAudioFiles" : serializedData.transcribedAudioFiles,
        "otherTrebbleAudioFiles":  serializedData.otherTrebbleAudioFiles,
        "saveTrigger" : operationNameWhichTriggerHistoryUpdate,
        "firstNodeCid": serializedData.firstNodeCid}

        serializedData.saveTrigger = operationNameWhichTriggerHistoryUpdate;
        serializedData.transcriptionJSONUrlToSpeakerInfoData = this._transcribeAudioArray.reduce((transcriptionJSONUrlToSpeakerInfoData, transcribedAudio)=>{
            transcriptionJSONUrlToSpeakerInfoData[transcribedAudio.getTranscriptJsonURL()] =  transcribedAudio.getAllSpeakerInfo().map((speakerInfo)=>{
                return speakerInfo.getSerializedData();
            })
            return transcriptionJSONUrlToSpeakerInfoData;
        }, {});
        const pendingSaveOperation = this._pendingSaveOperation ? this._pendingSaveOperation.catch(function(){
            return undefined;
        }) : RSVP.Promise.resolve();
        const isExpectedError = function(error){
            return !!(error && (
                (window.ExpectedError && error instanceof window.ExpectedError) ||
                error.name === "ExpectedError"
            ));
        };
        const isRetryableProjectSaveError = function(error){
            const errorString = error ? (typeof error === 'string' ? error : error.message || String(error)) : '';
            const normalizedErrorString = errorString.toLowerCase();
            const errorClassification = error && typeof error.classification === "string" ? error.classification.toLowerCase() : "";
            const errorI18nKey = error && typeof error.i18nKey === "string" ? error.i18nKey : "";
            const isExpectedNetworkError = isExpectedError(error) &&
                (errorClassification === "network" || errorI18nKey === "CONNECTION_LOST_UPLOAD");
            const isNetworkError = !!(error && typeof error === 'object' && error.isNetworkError);
            const isTransientFetchError = normalizedErrorString.includes("failed to fetch") ||
                normalizedErrorString.includes("networkerror") ||
                normalizedErrorString.includes("connection lost");

            return isNetworkError || isExpectedNetworkError || isTransientFetchError;
        };
        const tagProjectSaveStage = function(error, saveProjectStage){
            if(error && typeof error === "object" && !error.saveProjectStage){
                error.saveProjectStage = saveProjectStage;
            }
            return error;
        };
        const waitForProjectSaveRetry = function(retryDelayInMilliseconds){
            return new RSVP.Promise(function(resolve){
                setTimeout(resolve, retryDelayInMilliseconds);
            });
        };
        const workspaceId = typeof this.getWorkspaceId === "function" ? this.getWorkspaceId() : undefined;
        const executeProjectSaveAttempt = (function(attemptNumber){
            return TrebbleClientAPIHelper.getInstance().saveSequencerProject(createNewProjectId ? null : this.getProjectId(), new Date(), simplifiedSerializedData, true, workspaceId).catch(function(error){
                throw tagProjectSaveStage(error, "saveSequencerProject");
            }).then((function(operationResult){
                if(!(operationResult && operationResult.projectWasSaved && operationResult.preSignedUrlForUpload)){
                    return operationResult;
                }

                return FileUploadHelper.getInstance().uploadJSONToS3UsignPreSignedUrl(serializedData, operationResult.preSignedUrlForUpload).catch(function(error){
                    throw tagProjectSaveStage(error, "uploadJSONToS3");
                }).then((function(){
                    return TrebbleClientAPIHelper.getInstance().confirmProjectWasSuccessfullySaved(operationResult.serializedDataFileLocation).catch(function(error){
                        throw tagProjectSaveStage(error, "confirmProjectWasSuccessfullySaved");
                    });
                }).bind(this)).then(function(){
                    return operationResult;
                });
            }).bind(this)).catch((function(error){
                if(attemptNumber < SAVE_PROJECT_RETRY_DELAYS_IN_MILLISECONDS.length && isRetryableProjectSaveError(error)){
                    const retryDelayInMilliseconds = SAVE_PROJECT_RETRY_DELAYS_IN_MILLISECONDS[attemptNumber];
                    console.warn(
                        "Sequencer save failed during " + (error && error.saveProjectStage ? error.saveProjectStage : "save") +
                        " with a transient network error. Retrying in " + retryDelayInMilliseconds + "ms.",
                    );
                    return waitForProjectSaveRetry(retryDelayInMilliseconds).then((function(){
                        return executeProjectSaveAttempt(attemptNumber + 1);
                    }).bind(this));
                }
                throw error;
            }).bind(this));
        }).bind(this);
        this._pendingSaveOperation = pendingSaveOperation.then((function(){
            return executeProjectSaveAttempt(0);
        }).bind(this)).then((function(operationResult){
            if(operationResult.projectWasSaved){
                this.trigger("projectSavedSuccessfully");
                this.setProjectId(operationResult.projectId);
                this.setVersionedProjectId(operationResult.versionedProjectId || null);
                this.set("isBeingSaved", false);
                return operationResult;
            }

            if(operationResult.projectToBeSaveWasOlder){
                this.trigger("projectToBeSaveWasOlder");
            }else if(operationResult.authorNotAuthorizedToSave){
                this.trigger("authorNotAuthorizedToSave");
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("sequencer", 'savingSequencerProjectNotAuthorized', 'Saving sequencer project was not authorized');
                }
            }else{
                this.trigger("projectFailedToBeSaved");
                if(window.trebbleAnalyticsHelper){
                    window.trebbleAnalyticsHelper.trackEvent("sequencer", 'FailedSavingSequencerProject', 'Failed saving sequencer project');
                }
                window.sendErrorToRaygun('Failed saving sequencer project', true);
            }

            this.set("isBeingSaved", false);
            return operationResult;
        }).bind(this)).catch((function(error){
            this.trigger("projectFailedToBeSaved");
            const errorString = error ? (typeof error === 'string' ? error : error.message || String(error)) : '';
            const normalizedErrorString = errorString.toLowerCase();
            const isAuthError = normalizedErrorString.includes("unauthorised")
                || normalizedErrorString.includes("unauthorized")
                || normalizedErrorString.includes("login failed");
            const didUploadToS3Fail = !!(error && error.saveProjectStage === "uploadJSONToS3");
            const isExpectedErrorValue = isExpectedError(error);
            const isNetworkError = !!(error && typeof error === 'object' && error.isNetworkError);
            if(didUploadToS3Fail && window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'faileUploadingSequencerProjectToS3', 'Failed saving sequencer project to S3', null, {"error": error});
            }
            if(!isAuthError && !isExpectedErrorValue && !isNetworkError){
                window.sendErrorToRaygun('Failed saving sequencer project. Error:' + errorString, true);
            } else if (isNetworkError) {
                console.warn(
                    "Sequencer save failed due to a transient network error (operation=" +
                    (error.operationName || 'unknown') +
                    ", status=" + (error.httpStatus || 0) +
                    "). The next auto-save will retry.");
            }
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'FailedSavingSequencerProject', 'Failed saving sequencer project', null, {
                    isAuthError: isAuthError,
                    isExpectedError: isExpectedErrorValue,
                    isNetworkError: isNetworkError,
                    classification: (error && error.classification) || null,
                    i18nKey: (error && error.i18nKey) || null,
                    httpStatus: (error && error.httpStatus) || null,
                    operationName: (error && error.operationName) || null,
                    saveProjectStage: (error && error.saveProjectStage) || null
                });
            }
            this.set("isBeingSaved", false);
            throw error;
        }).bind(this));
        return this._pendingSaveOperation;
    },

    onAudioRenderingStarted : function(){
        this.trigger("sequencerRenderingStarted");
    },

    onAudioRenderingCompleted : function(){
        this.setRenderingBeingCreated(false);
        this.trigger("sequencerRenderingCompleted");
    },

    onAudioRenderingFailed : function(error){
        this.setRenderingBeingCreated(false);
        this.trigger("sequencerRenderingFailed", error);
    },

    getAllTranscriptionIds : function(){
        return this._transcribedAudioFiles.map((t)=>{
            return t.transcriptionId
        });
    },

    getFirstTranscriptionId: function(){
        const transcriptionIds =  this.getAllTranscriptionIds();
        return transcriptionIds && transcriptionIds.length > 0 ? transcriptionIds[0]: null
    },

    getAllTranscriptionMediaUrls : function(){
        return this._transcribedAudioFiles.map((t)=>{
            return t.audioFileUrl
        });
    },

    getTranscriptionIdForAudioUrl : function(audioUrl){
        for(let i = 0; i < this._transcribedAudioFiles.length;i++){
            const transcriptionAudioFileInfo = this._transcribedAudioFiles[i];
            if(transcriptionAudioFileInfo.audioFileUrl === audioUrl){
                return transcriptionAudioFileInfo.transcriptionId;
            }
        }
        return null;
    },

    areAllTranscribedFilesLoadedMatchingLanguage : function(genericLanguageCode){
        return this._transcribedAudioFiles.reduce((areAllMatchingLanguage,transcribedAudioFile)=>{
            if(areAllMatchingLanguage){
                return transcribedAudioFile && (!transcribedAudioFile.languageCode || transcribedAudioFile.languageCode.startsWith(genericLanguageCode));
            }else{
                return areAllMatchingLanguage;
            }
        }, true)
    },
    
    getAllLanguageCodesUsed: function(){
        return this._transcribedAudioFiles.reduce((arrayOfLanguageCodes,transcribedAudioFile)=>{
            if(transcribedAudioFile.languageCode && !arrayOfLanguageCodes.includes(transcribedAudioFile.languageCode)){
                arrayOfLanguageCodes.push(transcribedAudioFile.languageCode)
                return arrayOfLanguageCodes;
            }else{
                return arrayOfLanguageCodes;
            }
        }, [])
    },

    getFirstLanguageCodeUsed : function(){
        const  arrayOfLanguageCodes =  this.getAllLanguageCodesUsed();
        return arrayOfLanguageCodes && arrayOfLanguageCodes.length > 0? arrayOfLanguageCodes[0]: null;
    },

    addTranscribeAudio : function(audioUrl, transcriptionJsonURL, transcriptionId, doNotAddToSequencer, isVideo, progressReportFunction, speakerInfoSerializedDataArray, additionalSpeakerInfoArray, languageCode, videoWidth, videoHeight){
        this.trigger("audioTranscribedBeingAdded");
        this._transcribedAudioFiles.push({ audioFileUrl:audioUrl, transcriptionFileLocation : transcriptionJsonURL, transcriptionId: transcriptionId, isVideo: isVideo, languageCode, videoWidth, videoHeight});
        return this.getAudioBufferCache().loadAudioBufferFromUrl(audioUrl, audioUrl, AudioBufferHelper.getInstance().getAudioTypes().VOICE, this.getSequencerSettings(), progressReportFunction).then((function(audioBuffer){
            if(progressReportFunction){
                progressReportFunction(null, window.getI18n(ti18n, "PARSING_TRANSCRIPTION"))
            }
            return SequencerLibrary.getInstance().getTranscribeAudio(audioUrl, transcriptionJsonURL, audioBuffer? AudioBufferHelper.getInstance().getMaxAudioBufferDuration(audioBuffer)*1000: 0, transcriptionId, isVideo, speakerInfoSerializedDataArray, additionalSpeakerInfoArray, this.generateSpeakerLabelIfDuplicate.bind(this), languageCode,  videoWidth, videoHeight,);
        }).bind(this)).then((function(transcribeAudio){
            if(transcribeAudio && transcribeAudio.getAudioSegmentArray() && !doNotAddToSequencer){
                const audioSegmentArray = transcribeAudio.getAudioSegmentArray();
                for(let i = 0; i < audioSegmentArray.length; i++){
                    const audioSegment = audioSegmentArray[i];
                    const functionToCreateSequencerNode = (function(){
                        return this._createSequencerNode(audioSegment);
                    }).bind(this)
                    this._addSequencerNodeToTheEnd(functionToCreateSequencerNode);
                }
            }
            if(transcribeAudio){
                this._transcribeAudioArray.push(transcribeAudio);
            }
            this.trigger("audioTranscribedAdded");
            return transcribeAudio;
        }).bind(this))
    },

    createSequencerNodesFromTransribedAudio : function(transcribedAudio){
        if(transcribedAudio && transcribedAudio.getAudioSegmentArray()){
            return transcribedAudio.getAudioSegmentArray().map((audioSegment)=>{
                return this._createSequencerNode(audioSegment);
            })
        }
        return [];
    },

    /*getFirstNode : function(){
        //return this._firstNode;
        return this._collection.at(0);
    },*/	

    _createSequencerNode : function(audioSegment){
        let sequencerNode =  null;
        if(Utils.getInstance().isPauseAudioSegmentInstance(audioSegment)){
            sequencerNode  = new PauseSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isDeletedAudioSegmentInstance(audioSegment)){
            sequencerNode  = new DeletedSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isWordAudioSegmentInstance(audioSegment)){
            sequencerNode  = new WordSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isAudioEventAudioSegmentInstance(audioSegment)){
            sequencerNode  = new AudioEventSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        
        if(Utils.getInstance().isPunctuationAudioSegmentInstance(audioSegment)){
            sequencerNode  = new PunctuationSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isUnsupportedAudioSegmentInstance(audioSegment)){
            sequencerNode  = new UnsupportedAudioSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isCloudAudioSegmentInstance(audioSegment)){
            sequencerNode  = new AudioSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        if(Utils.getInstance().isCloudVideoSegmentInstance(audioSegment)){
            sequencerNode  = new VideoSequencerNode({"audioSegment": audioSegment,"sequencer": this});
        }
        return sequencerNode;
    },

    addToSequencerNodeCreated : function(sequencerNodeCreated){
        this._cidToSegmentNodeMap[sequencerNodeCreated.getCid()] = sequencerNodeCreated;
    },

    setFirstNode : function(sequencerNode){
        this._firstNode = sequencerNode;
    },

    getFirstNode : function(){
        return this._firstNode;
    },

    setLastNode : function(sequencerNode){
        this._lastNode = sequencerNode;
    },

    getLastNode : function(){
        //return this._lastNode;
        return this._collection.at(this._collection.length - 1)
    },


    updateClipboard : function(startSequencerNodeModel, endSequencerNodeModel, shouldBeClonedWhenRetrieved){
        this._sequencerClipboard.updateClipboard(startSequencerNodeModel, endSequencerNodeModel, shouldBeClonedWhenRetrieved);
    },

    isClipboardEmpty : function(){
        return this._sequencerClipboard.isClipboardEmpty();
    },

    getSequencerNodeByNodeCid: function(nodeCid){
        return this._cidToSegmentNodeMap[nodeCid];
    },


    _addSequencerNodeToTheEnd : function(functionToCreateSequnecerNode){
        const sequencerNode = functionToCreateSequnecerNode();
        //this.addToSequencerNodeCreated(sequencerNode);
        if(!this._firstNode){
            this._firstNode = sequencerNode;
        }
        if(!this._lastNode){
            this._lastNode = sequencerNode;
        }else{
            this._lastNode.setNext(sequencerNode);
        }

        this._lastNode = sequencerNode;
        sequencerNode.addToSequencer();
        return sequencerNode;
    },

    add : function(model){
        const previousNode = model.getPrevious();
        const nextNode = model.getNext();
        const indexOfPreviousNode = previousNode?this._collection.indexOf(previousNode): -1;
        if(indexOfPreviousNode > -1){
            return this._collection.add(model, {"at": indexOfPreviousNode+1});
        }
        const indexOfNextNode = nextNode?this._collection.indexOf(nextNode): -1;
        if(indexOfNextNode > -1){
            return this._collection.add(model, {"at": indexOfNextNode});
        }
        //Just in case then add without an index
        return this._collection.add(model);
    },

    remove : function(model){
        this._collection.remove(model);
    },

    getAllSequencerNodesInRange : function(audioUrl, startTime, endTime, filterConditionFunction, hasToBeInsideTheRange ){
        const matchingSequencerNodes = [];
        Object.values(this._cidToSegmentNodeMap).map((function(sequencerNode){
            if(sequencerNode.getAudioSegment() && sequencerNode.getAudioSegment().getAudioUrl() === audioUrl && (!filterConditionFunction || filterConditionFunction(sequencerNode))){
                if(hasToBeInsideTheRange){
                    if(sequencerNode.getAudioSegment().getStartTime() >=  startTime && sequencerNode.getAudioSegment().getEndTime() <= endTime){
                        matchingSequencerNodes.push(sequencerNode)
                    }
                }else{
                    if((sequencerNode.getAudioSegment().getStartTime() >=  startTime && sequencerNode.getAudioSegment().getStartTime() < endTime) || (sequencerNode.getAudioSegment().getEndTime() <= endTime &&  sequencerNode.getAudioSegment().getEndTime() > startTime)){
                        matchingSequencerNodes.push(sequencerNode)
                    }
                }
            }
        }).bind(this))
        return matchingSequencerNodes;

    },

    deleteSelectedNodes : function(startSequencerNodeToDelete, endSequencerNodeToDelete, deletionSource ){
        if(!this.hasMutationAccess()){
            return null;
        }
        try{
            const deleteNodeCreated =  this._deleteSelectedNodesOperation.execute(startSequencerNodeToDelete, endSequencerNodeToDelete, deletionSource);
            return deleteNodeCreated;
        }catch(error){
            if(error instanceof DeleteSelectedNodesOperation.InterruptedBecauseOfWrapNodeOrphanError){
                this.trigger("deleteOperationInteruptedBecauseOfWrapNodeOrphan");
            }else{
                if(error instanceof DeleteSelectedNodesOperation.SelectedNodeNeedToBeNextToEachotherError){
                    this.trigger("selectedNodeNeedToBeNextToEachotherError");
                }else{
                    throw error;
                }
            }
        }
        return null;
    },

    undoDeleteSelectedNodes : function(sequencerOperationDeleteNodesLog ){
        return this._deleteSelectedNodesOperation.undo(sequencerOperationDeleteNodesLog);
    },

    redoDeleteSelectedNodes : function(sequencerOperationDeleteNodesLog ){
        return this._deleteSelectedNodesOperation.redo(sequencerOperationDeleteNodesLog);
    },

    undoDeleteSelectedNodesBulk : function(sequencerOperationCreateDeleteNodesBulkLog ){
        return this._deleteBulkSelectedNodesOperation.undo(sequencerOperationCreateDeleteNodesBulkLog);
    },

    redoDeleteSelectedNodesBulk : function(sequencerOperationCreateDeleteNodesBulkLog ){
        return this._deleteBulkSelectedNodesOperation.redo(sequencerOperationCreateDeleteNodesBulkLog);
    },

    revertDeletedNodeCreation : function(deletedSequencerNode){
        return this._revertDeleteSelectedNodesOperation.execute(deletedSequencerNode);
    },

    undoRevertDeletedNodeCreation : function(sequencerOperationDeleteDeleteNodesLog){
        return this._revertDeleteSelectedNodesOperation.undo(sequencerOperationDeleteDeleteNodesLog);
    },

    redoRevertDeletedNodeCreation : function(sequencerOperationDeleteDeleteNodesLog){
        return this._revertDeleteSelectedNodesOperation.redo(sequencerOperationDeleteDeleteNodesLog);
    },

    wrapSelectedNodesWithMusic : function(trebbleAudio,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds, outroFadeInMilliseconds, volumePercentage, loopToMatchWrapNodeDuration, ducking,  startSequencerNodeToWrap, endSequencerNodeToWrap ){
        return this._wrapSelectedNodesWithAudioOperation.execute(trebbleAudio,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds, outroFadeInMilliseconds, volumePercentage, loopToMatchWrapNodeDuration,ducking,  startSequencerNodeToWrap, endSequencerNodeToWrap);
    },

    undoWrapSelectedNodesWithMusic : function(sequencerOperationWrapWithMusicLog){
        return this._wrapSelectedNodesWithAudioOperation.undo(sequencerOperationWrapWithMusicLog);
    },

    redoWrapSelectedNodesWithMusic : function(sequencerOperationWrapWithMusicLog){
        return this._wrapSelectedNodesWithAudioOperation.redo(sequencerOperationWrapWithMusicLog);
    },

    deleteMusicWrapNodeCreated : function(startOrEndMusicWrapSequencerNode){
        return this._deleteWrapWithAudioNodesOperation.execute(startOrEndMusicWrapSequencerNode);
    },

    undoDeleteMusicWrapNodeCreation : function(sequencerOperationDeleteWrapWithMusicLog){
        return this._deleteWrapWithAudioNodesOperation.undo(sequencerOperationDeleteWrapWithMusicLog);
    },

    redoDeleteMusicWrapNodeCreation : function(sequencerOperationDeleteWrapWithMusicLog){
        return this._deleteWrapWithAudioNodesOperation.redo(sequencerOperationDeleteWrapWithMusicLog);
    },

    wrapSelectedNodesWithMute : function(startSequencerNodeToWrap, endSequencerNodeToWrap){
        return this._wrapSelectedNodesWithMuteOperation.execute(startSequencerNodeToWrap, endSequencerNodeToWrap);
    },

    undoWrapSelectedNodesWithMute : function(sequencerOperationWrapWithMuteLog){
        return this._wrapSelectedNodesWithMuteOperation.undo(sequencerOperationWrapWithMuteLog);
    },

    redoWrapSelectedNodesWithMute : function(sequencerOperationWrapWithMuteLog){
        return this._wrapSelectedNodesWithMuteOperation.redo(sequencerOperationWrapWithMuteLog);
    },

    deleteMuteWrapNodeCreated : function(startOrEndMuteWrapSequencerNode){
        return this._deleteWrapWithMuteNodesOperation.execute(startOrEndMuteWrapSequencerNode);
    },

    undoDeleteMuteWrapNodeCreation : function(sequencerOperationDeleteWrapWithMuteLog){
        return this._deleteWrapWithMuteNodesOperation.undo(sequencerOperationDeleteWrapWithMuteLog);
    },

    redoDeleteMuteWrapNodeCreation : function(sequencerOperationDeleteWrapWithMuteLog){
        return this._deleteWrapWithMuteNodesOperation.redo(sequencerOperationDeleteWrapWithMuteLog);
    },

    deleteAudioSequencerNodeCreated: function(audioSequencerNode){
        return this._deleteAudioSequencerNodeOperation.execute(audioSequencerNode);
    },

    undoDeleteAudioSequencerNodeCreated : function(sequencerOperationDeleteAudioNodeLog){
        return this._deleteAudioSequencerNodeOperation.undo(sequencerOperationDeleteAudioNodeLog);
    },

    redoDeleteAudioSequencerNodeCreated : function(sequencerOperationDeleteAudioNodeLog){
        return this._deleteAudioSequencerNodeOperation.redo(sequencerOperationDeleteAudioNodeLog);
    },

    updateSequencerNodeProperty : function(sequencerNode, updatePropertyFunctionName, retrievePropertyFunctionName, newValue){
        return this._updateSequencerNodePropertyOperation.execute(sequencerNode, updatePropertyFunctionName, retrievePropertyFunctionName, newValue);
    },

    undoUpdatePropertyOnSequencerNode : function(sequencerOperationChangeSequencerNodePropertyLog){
        return this._updateSequencerNodePropertyOperation.undo(sequencerOperationChangeSequencerNodePropertyLog);
    },

    redoUpdatePropertyOnSequencerNode : function(sequencerOperationChangeSequencerNodePropertyLog){
        return this._updateSequencerNodePropertyOperation.redo(sequencerOperationChangeSequencerNodePropertyLog);
    },

    moveWrapNode : function(startOrEndWrapSequencerNodeToMove,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode){
        return this._moveWrapNodesOperation.execute(startOrEndWrapSequencerNodeToMove,oldIndexInSequencer,  newIndexInSequencer, newPreviousSequencerNode, newNextSequencerNode);
    },

    undoMoveWrapNode : function(sequencerOperationMoveWrapNodesLog){
        return this._moveWrapNodesOperation.undo(sequencerOperationMoveWrapNodesLog);
    },

    redoMoveWrapNode : function(sequencerOperationMoveWrapNodesLog){
        return this._moveWrapNodesOperation.redo(sequencerOperationMoveWrapNodesLog);
    },

    moveNode : function(nodeToMove, newPreviousSequencerNode, newNextSequencerNode){
        return this._moveNodeOperation.execute(nodeToMove, newPreviousSequencerNode, newNextSequencerNode);
    },

    undoMoveNode : function(sequencerOperationMoveNodeLog){
        return this._moveNodeOperation.undo(sequencerOperationMoveNodeLog);
    },

    redoMoveNode : function(sequencerOperationMoveNodeLog){
        return this._moveNodeOperation.redo(sequencerOperationMoveNodeLog);
    },

    insertAudioNode : function(trebbleAudio, sequencerNodeToInsertNextTo, insertBefore,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds,outroFadeinMilliseconds, volume){
        return this._insertAudioNodeOperation.execute(trebbleAudio, sequencerNodeToInsertNextTo, insertBefore,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds, outroFadeinMilliseconds, volume);
    },

    undoInsertAudioNode : function(sequencerOperationInsertAudioNodeLog){
        return this._insertAudioNodeOperation.undo(sequencerOperationInsertAudioNodeLog);
    },

    redoInsertAudioNode : function(sequencerOperationInsertAudioNodeLog){
        return this._insertAudioNodeOperation.redo(sequencerOperationInsertAudioNodeLog);
    },

    insertVideoNode : function(trebbleVideo, sequencerNodeToInsertNextTo, insertBefore,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds,outroFadeinMilliseconds, volume){
        return this._insertVideoNodeOperation.execute(trebbleVideo, sequencerNodeToInsertNextTo, insertBefore,introPaddingInMilliseconds, outroPaddingInMilliseconds, introFadeInMilliseconds, outroFadeinMilliseconds, volume);
    },

    undoInsertVideoNode : function(sequencerOperationInsertVideoNodeLog){
        return this._insertVideoNodeOperation.undo(sequencerOperationInsertVideoNodeLog);
    },

    redoInsertVideoNode : function(sequencerOperationInsertVideoNodeLog){
        return this._insertVideoNodeOperation.redo(sequencerOperationInsertVideoNodeLog);
    },

    deleteAllExceptSelectedNodes : function(startSequencerNodeToKeep, endSequencerNodeToKeep){
        this._deleteAllExceptSelectedNodesOperation.execute(startSequencerNodeToKeep, endSequencerNodeToKeep);
    },

    undoDeleteAllExceptSelectedNodes : function(sequencerOperationDeleteAllExceptSelectedNodesLog){
        this._deleteAllExceptSelectedNodesOperation.undo(sequencerOperationDeleteAllExceptSelectedNodesLog);
    },

    redoDeleteAllExceptSelectedNodes : function(sequencerOperationDeleteAllExceptSelectedNodesLog){
        this._deleteAllExceptSelectedNodesOperation.redo(sequencerOperationDeleteAllExceptSelectedNodesLog);
    },

    insertAudioOrVideoNodesInBulk: function(sequencerNodeTargetToInsertBefore, insertBefore, audioOrVideoModelsToInsert){
        return this._insertAudioOrVideoNodesInBulkOperation.execute(sequencerNodeTargetToInsertBefore, insertBefore, audioOrVideoModelsToInsert);
    },

    undoInsertAudioOrVideoNodesBulk: function(sequencerOperationInsertAudioOrVideoNodesInBulkLog){
        this._insertAudioOrVideoNodesInBulkOperation.undo(sequencerOperationInsertAudioOrVideoNodesInBulkLog);
    },

    redoInsertAudioOrVideoNodesBulk: function(sequencerOperationInsertAudioOrVideoNodesInBulkLog){
        this._insertAudioOrVideoNodesInBulkOperation.redo(sequencerOperationInsertAudioOrVideoNodesInBulkLog);
    },


    getAllLoadedTranscribedFilesWithoutEnhancedCounterpart : async function(){
        const arrayToReturn = await this._transcribedAudioFiles.reduce((async function (urlWihoutCounterPartArrayPromise, transcribedFileInfo){
            const urlWihoutCounterPartArray = await urlWihoutCounterPartArrayPromise;
            const enhancedVersionCounterPartUrl =  await this.getAudioBufferCache().getEnhancedSpeechVersionUrlForMediaFile(transcribedFileInfo.audioFileUrl);
            if(!enhancedVersionCounterPartUrl){
                urlWihoutCounterPartArray.push(transcribedFileInfo.audioFileUrl);
            }
            return urlWihoutCounterPartArray;
        }).bind(this),[]);
        return arrayToReturn;
    },

    triggerSpeechEnhancementForTranscribedUrlsAndToggleEnhancementSettingsWhenReady : async function(audioUrls){
            TrebbleNotificationManager.createLoadingNotification(audioUrls[0],  null, window.getI18n(ti18n, "YOUR_FILE_IS_BEING_ENHANCED")+" " +window.getI18n(ti18n, "THIS_MIGHT_TAKE_A_FEW_MINUTES_WE_WILL_NOTIFY_YOU"),{ duration: 0 ,darkTheme: false,  placement:"bottomRight"});
            const transcribedFileInfoToEnhanceArray =  this._transcribedAudioFiles.reduce((transcribedFileInfoToEnhanceArray, transcribedFileInfo)=>{
            if(audioUrls.includes(transcribedFileInfo.audioFileUrl)){
                transcribedFileInfoToEnhanceArray.push(transcribedFileInfo);
            }
            return transcribedFileInfoToEnhanceArray;
        },[])
        await this.getAudioBufferCache().enhanceTranscribedFilesAndTunOnSetting(transcribedFileInfoToEnhanceArray, this);

    },

    setNoiseCancellation: function(on, doNoRecordInHistory){
        if(!this.hasMutationAccess()){
            return;
        }
        if(doNoRecordInHistory){
            this.getSequencerSettings().setNoiseCancellation(on);
        }else{
            this._turnNoiseCancellationOnOperation.execute(!this.getSequencerSettings().isNoiseCancellationOn());
            if(!this._warnedUserForFirstNoiseCancellation && this.getSequencerSettings().isNoiseCancellationOn()){
                this._warnedUserForFirstNoiseCancellation = true;
                this.trigger("firstNoiseCancellationTurnedOn")
            }
        }
    },

    toggleNoiseCancellation: function(){
        if(!this.hasMutationAccess()){
            return;
        }

        this._turnNoiseCancellationOnOperation.execute(!this.getSequencerSettings().isNoiseCancellationOn());
        if(!this._warnedUserForFirstNoiseCancellation && this.getSequencerSettings().isNoiseCancellationOn()){
            this._warnedUserForFirstNoiseCancellation = true;
            this.trigger("firstNoiseCancellationTurnedOn")
        }
    },

    setMagicSoundEnhancer: function(on, doNoRecordInHistory){
        if(!this.hasMutationAccess()){
            return;
        }
        if(doNoRecordInHistory){
            this.getSequencerSettings().setMagicSoundEnhancerOn(on);
        }else{
            this._turnMagicSoundEnhancerOnOperation.execute(!this.getSequencerSettings().isMagicSoundEnhancerOn());
            if(!this._warnedUserForFirstMagicSoundEnhancer && this.getSequencerSettings().isMagicSoundEnhancerOn()){
                this._warnedUserForFirstMagicSoundEnhancer = true;
                this.trigger("firstMagicSoundEnhancerTurnedOn")
            }
        }
    },

    toggleMagicSoundEnhancer: function(){
        if(!this.hasMutationAccess()){
            return;
        }

        this._turnMagicSoundEnhancerOnOperation.execute(!this.getSequencerSettings().isMagicSoundEnhancerOn());
        if(!this._warnedUserForFirstMagicSoundEnhancer && this.getSequencerSettings().isMagicSoundEnhancerOn()){
            this._warnedUserForFirstMagicSoundEnhancer = true;
            this.trigger("firstMagicSoundEnhancerTurnedOn")
        }
    },


    undoToggleNoiseCancellation : function(sequencerOperationTurnNoiseCancellationOnOperationLog){
        return this._turnNoiseCancellationOnOperation.undo(sequencerOperationTurnNoiseCancellationOnOperationLog);
    },

    redoToggleNoiseCancellation : function(sequencerOperationTurnNoiseCancellationOnOperationLog){
        return this._turnNoiseCancellationOnOperation.redo(sequencerOperationTurnNoiseCancellationOnOperationLog);
    },

    undoToggleMagicSoundEnhancer : function(sequencerOperationTurnMagicSoundEnhancerOnOperationLog){
        return this._turnMagicSoundEnhancerOnOperation.undo(sequencerOperationTurnMagicSoundEnhancerOnOperationLog);
    },

    redoToggleMagicSoundEnhancer : function(sequencerOperationTurnMagicSoundEnhancerOnOperationLog){
        return this._turnMagicSoundEnhancerOnOperation.redo(sequencerOperationTurnMagicSoundEnhancerOnOperationLog);
    },

    pasteClipboard : function(sequencerNodeToInsertNextTo, insertBefore){
        return this._insertNodeArrayOperation.execute(this._sequencerClipboard.getSequencerNodesInClipboard(), sequencerNodeToInsertNextTo, insertBefore);
    },

    undoInsertNodeArray: function(sequencerOperationInsertNodeArrayOperationLog){
        return this._insertNodeArrayOperation.undo(sequencerOperationInsertNodeArrayOperationLog);
    },

    redoInsertNodeArray: function(sequencerOperationInsertNodeArrayOperationLog){
        return this._insertNodeArrayOperation.redo(sequencerOperationInsertNodeArrayOperationLog);
    },

    cutAndCopyToClipboard : function(startSequencerNodeModel, endSequencerNodeModel){
        return this._cutAndCopyToClipboardOperation.execute(startSequencerNodeModel, endSequencerNodeModel);
    },

    undoCutAndCopyToClipboard: function(sequencerOperationCutAndCopyToClipboardOperationLog){
        return this._cutAndCopyToClipboardOperation.undo(sequencerOperationCutAndCopyToClipboardOperationLog);
    },

    redoCutAndCopyToClipboard: function(sequencerOperationCutAndCopyToClipboardOperationLog){
        return this._cutAndCopyToClipboardOperation.redo(sequencerOperationCutAndCopyToClipboardOperationLog);
    },


    setSequencerSettings : function(settingToChange, settingValue, silent){
        return this._sequencerSettingsChangeOperation.execute(settingToChange, settingValue, silent);
    },

    undoSequencerSettingChange: function(sequencerOperationSettingsChangeLog){
        return this._sequencerSettingsChangeOperation.undo(sequencerOperationSettingsChangeLog);
    },

    redoSequencerSettingChange: function(sequencerOperationSettingsChangeLog){
        return this._sequencerSettingsChangeOperation.redo(sequencerOperationSettingsChangeLog);
    },

    transcribeSequencerNode : async function(sequencerNode, languageCode, onTranscriptionStarted, onTranscriptionEnded, onReplacementStarted, onReplacementEnded){
        return this._transcribeAndReplaceOperation.execute(sequencerNode, languageCode, onTranscriptionStarted, onTranscriptionEnded, onReplacementStarted, onReplacementEnded);
    },

    undoTransribeAndReplaceSequencerNode : function(sequencerOperationTranscribeAndReplaceSequencerNodeLog){
        return this._transcribeAndReplaceOperation.undo(sequencerOperationTranscribeAndReplaceSequencerNodeLog);
    },

    redoTransribeAndReplaceSequencerNode : function(sequencerOperationTranscribeAndReplaceSequencerNodeLog){
        return this._transcribeAndReplaceOperation.redo(sequencerOperationTranscribeAndReplaceSequencerNodeLog);
    },

    deleteSequencerNode: function(sequencerNode){
        return this._deleteSequencerNodeOperation.execute(sequencerNode);
    },

    undoDeleteSequencerNode: function(sequencerOperationDeleteNodeLog){
        return this._deleteSequencerNodeOperation.undo(sequencerOperationDeleteNodeLog);
    },

    redoDeleteSequencerNode: function(sequencerOperationDeleteNodeLog){
        return this._deleteSequencerNodeOperation.redo(sequencerOperationDeleteNodeLog);
    },

    getLoadedProjectId : function(){
        return this._loadedProjectId;
    },

    loadProject: function(projectId, sequencerNodeToInsertNextTo, insertBefore, clearExistingProject, duplicateProject,  silent, progressReportFunction){
        this._loadedProjectId = projectId;
        return this._loadProjectOperation.execute(projectId, sequencerNodeToInsertNextTo, insertBefore, clearExistingProject, duplicateProject, silent, progressReportFunction);
    },

    undoLoadProject : function(sequencerOperationLoadProjectLog){
        return this._loadProjectOperation.undo(sequencerOperationLoadProjectLog);
    },

    redoLoadProject : function(sequencerOperationLoadProjectLog){
        return this._loadProjectOperation.redo(sequencerOperationLoadProjectLog);
    },

    correctTextOnSequencerNodes : function(arrayOfSequencerNodes, newTranscriptText){
        if(arrayOfSequencerNodes && arrayOfSequencerNodes.length === 1 && newTranscriptText && newTranscriptText.trim().length >0 ){
            this._correctTranscriptOnSingleSequencerNodeOperation.execute(arrayOfSequencerNodes[0], newTranscriptText);
        }
    },

    undoCorrectTextOnSequencerNodes : function(sequencerOperationCorrectTranscriptSingleSequencerNodeOperationLog){
        return this._correctTranscriptOnSingleSequencerNodeOperation.undo(sequencerOperationCorrectTranscriptSingleSequencerNodeOperationLog);
    },

    redoCorrectTextOnSequencerNodes : function(sequencerOperationCorrectTranscriptSingleSequencerNodeOperationLog){
        return this._correctTranscriptOnSingleSequencerNodeOperation.redo(sequencerOperationCorrectTranscriptSingleSequencerNodeOperationLog);
    },

    renameSpeakerInfo : function(speakerInfo, newModifiedSpeakerLabel){
        if(speakerInfo && newModifiedSpeakerLabel){
            return this._renameSpeakerNameSequencerOperation.execute(speakerInfo, newModifiedSpeakerLabel);
        }
    },

    undoRenameSpeakerInfo : function(sequencerOperationRenameSpeakerLabelLog){
        return this._renameSpeakerNameSequencerOperation.undo(sequencerOperationRenameSpeakerLabelLog);
    },

    redoRenameSpeakerInfo : function(sequencerOperationRenameSpeakerLabelLog){
        return this._renameSpeakerNameSequencerOperation.redo(sequencerOperationRenameSpeakerLabelLog);
    },

    createNewSpeakerInfoAndAssign : function(speakerLabel, _paragraphContainerView, startSequencerNodeToAssign, endSequencerNodeToAssign, arrayOfSequencerNodeToAssign){
        if(speakerLabel && startSequencerNodeToAssign && endSequencerNodeToAssign){
            return this._createNewSpeakerAndAssignToSequencerNodesOperation.execute(
                speakerLabel,
                _paragraphContainerView,
                startSequencerNodeToAssign,
                endSequencerNodeToAssign,
                arrayOfSequencerNodeToAssign,
            );
        }
    },

    undoCreateNewSpeakerInfoAndAssign : function(sequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog){
        return this._createNewSpeakerAndAssignToSequencerNodesOperation.undo(sequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog);
    },

    redoCreateNewSpeakerInfoAndAssign : function(sequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog){
        return this._createNewSpeakerAndAssignToSequencerNodesOperation.redo(sequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog);
    },

    changeSpeakerParagraph: function(_paragraphContainerView, newSpeakerInfo, startSequencerNodeToChange, endSequencerNodeToChange, arrayOfSequencerNodeToChange){
        return this._changeSpeakerForParagraphOperation.execute(_paragraphContainerView, newSpeakerInfo, startSequencerNodeToChange, endSequencerNodeToChange, arrayOfSequencerNodeToChange);
    },

    undoChangeSpeakerParagraph: function(sequencerOperationChangeSpeakerForParagraphOperationLog){
        return this._changeSpeakerForParagraphOperation.undo(sequencerOperationChangeSpeakerForParagraphOperationLog);
    },

    redoChangeSpeakerParagraph: function(sequencerOperationChangeSpeakerForParagraphOperationLog){
        return this._changeSpeakerForParagraphOperation.redo(sequencerOperationChangeSpeakerForParagraphOperationLog);
    },

    changeParagraphBoundaryPreference : function(sequencerNode, paragraphBoundaryPreference){
        return this._changeParagraphBoundaryPreferenceOperation.execute(sequencerNode, paragraphBoundaryPreference);
    },

    undoChangeParagraphBoundaryPreference : function(sequencerOperationChangeParagraphBoundaryPreferenceLog){
        return this._changeParagraphBoundaryPreferenceOperation.undo(sequencerOperationChangeParagraphBoundaryPreferenceLog);
    },

    redoChangeParagraphBoundaryPreference : function(sequencerOperationChangeParagraphBoundaryPreferenceLog){
        return this._changeParagraphBoundaryPreferenceOperation.redo(sequencerOperationChangeParagraphBoundaryPreferenceLog);
    },

    


    getRenderedAudioBlob : function(renderWavFile, asVideo, progressReportFunction, alreadyRenderedAudioWAVBlob, skipAudioProcessing){
        return SequencerRendererHelper.getInstance().getRenderedAudioBlob(this, true, renderWavFile, asVideo, progressReportFunction, alreadyRenderedAudioWAVBlob, null, false, skipAudioProcessing)
    },

    getRenderedAudioBlobClip : function(renderWavFile, sequencerNodeToStartFrom, sequencerNodeToEndOn, asVideo, progressReportFunction, alreadyRenderedAudioWAVBlob, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible, skipAudioProcessing){
        return SequencerRendererHelper.getInstance().getRenderedAudioBlobClip(this, true, renderWavFile, sequencerNodeToStartFrom, sequencerNodeToEndOn,  asVideo, progressReportFunction, alreadyRenderedAudioWAVBlob,  shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible, skipAudioProcessing);
    },

    /**
     * Get prepared video data for clip creation (merged node scheduling info array)
     * Public API that delegates to helper and renderer implementation layers
     * @param {SequencerNode} sequencerNodeToStartFrom - Starting node
     * @param {SequencerNode} sequencerNodeToEndOn - Ending node
     * @param {Function} shouldSequencerNodeBePlayedValidatorFunction - Validator function
     * @param {boolean} includeDeletedSegmentsWhenPossible - Include deleted segments
     * @param {Function} progressCallback - Progress callback function(percentage, message)
     * @returns {Promise<Array>} Array of merged node scheduling info objects
     */
    getPreparedVideoDataForClipCreation : function(sequencerNodeToStartFrom, sequencerNodeToEndOn, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible, progressCallback){
        return SequencerRendererHelper.getInstance().getPreparedVideoDataForClipCreation(this, sequencerNodeToStartFrom, null, sequencerNodeToEndOn,  null, window.chrome && EDIT_VIDEO_FILES? this.getActiveVideoRenderer(): null, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible, progressCallback);
    },

    getSrtText : function(sequencerNodeToStartFrom, sequencerNodeToEndOn, progressReportFunction, asVtt, doNotIncludeSpeaker, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible){
        return SequencerRendererHelper.getInstance().getSrtText(this,sequencerNodeToStartFrom, sequencerNodeToEndOn, progressReportFunction, asVtt, doNotIncludeSpeaker, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible);
    },

    getTranscriptionAndEditsInfo : function(sequencerNodeToStartFrom, sequencerNodeToEndOn, progressReportFunction, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible){
        return SequencerRendererHelper.getInstance().getTranscriptionAndEditsInfo(this,sequencerNodeToStartFrom, sequencerNodeToEndOn, progressReportFunction, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible);
    },

    createFFMPEGParamsToRenderVideoByContatenation : function(applyMasterProcessing, audioUrl,sequencerNodeToStartFrom, sequencerNodeToEndOn, srtFileUrl ){
        return SequencerRendererHelper.getInstance().createFFMPEGParamsToRenderVideoByContatenation(this, applyMasterProcessing, sequencerNodeToStartFrom? sequencerNodeToStartFrom : this.getFirstNode(), sequencerNodeToEndOn? sequencerNodeToEndOn: this.getLastNode(), audioUrl, srtFileUrl);
    },

    createFFMPEGParamsByContatenationForServerRendering : function(applyMasterProcessing, sequencerNodeToStartFrom, sequencerNodeToEndOn, audioUrl, maxDurationInMilliseconds){
        // Parameters: sequencer, applyMasterProcessing, startNode, endNode, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible, maxDurationInMilliseconds, audioUrl
        return SequencerRendererHelper.getInstance().createFFMPEGParamsByContatenationForServerRendering(
            this,
            applyMasterProcessing,
            sequencerNodeToStartFrom ? sequencerNodeToStartFrom : this.getFirstNode(),
            sequencerNodeToEndOn ? sequencerNodeToEndOn : this.getLastNode(),
            null,  // shouldSequencerNodeBePlayedValidatorFunction
            false, // includeDeletedSegmentsWhenPossible
            maxDurationInMilliseconds,
            audioUrl
        );
    },

    isSequencerNodeVisible : function(sequencerNode){
        if(Utils.getInstance().isPunctuationSequencerNodeInstance(sequencerNode)){
            return false;
        }
        if(Utils.getInstance().isDeletedSequencerNodeInstance(sequencerNode)){
            if(!this.getSequencerSettings().isShowIgnoredContent()){
                return false;
            }
        }
        if(Utils.getInstance().isPauseSequencerNodeInstance(sequencerNode)){
            if(!this.getSequencerSettings().isShowGapsBetweenWords()){
                return false;
            }
            if(DO_NOT_SHOW_NON_EXPLICITELY_DISPLAYED_PAUSE){
                if(sequencerNode.getAudioSegment() && sequencerNode.getAudioSegment().isExplicitlyDisplayed()){
                    return false;
                }
            }
        }
        return true;
    },

    showNotDisplayedNotExplicitelyDisplayedPause : function(){
        return !DO_NOT_SHOW_NON_EXPLICITELY_DISPLAYED_PAUSE;
    },

    getAllSequencerNodesInSequencer : function(){
        return this._collection.models;
    },

    getNumberOfVisibleSequencerNodes : function(){
        return this._collection.models.reduce((function(numberOfVisibleSequencerNodesCount, sequencerNode){
            return this.isSequencerNodeVisible(sequencerNode)? numberOfVisibleSequencerNodesCount+1: numberOfVisibleSequencerNodesCount;
        }).bind(this), 0)
    },

    getHistoryManagement :function(){
        return this._historyManagement;
    },

    isPlaying : function(){
        return SequencerRendererHelper.getInstance().isPlaying(this);
    },

    updatePlaybackPositionInMilliseconds : function(timeInMilliseconds){
        if(SequencerRendererHelper.getInstance().isPlaying(this)){
            return this.playSequencerRenderingFromPositionInMilliseconds(timeInMilliseconds);
        }else{
            this._playbackProgressInMillisecondsBeforePausing = timeInMilliseconds;
        }
    },

    playPauseSequencerRenderingFromNode : function(nodeToPlayFrom, forcePlay, stopAfterMilliseconds, nodeToStopPlayAt, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible){
        this.getAudioBufferCache().resumeAudiContextToKeepHeartbeat();
        if(SequencerRendererHelper.getInstance().isPlaying(this)){
            this._playbackProgressInMillisecondsBeforePausing = this.getPlaybackProgressInMilliseconds();
        }
        
        const startTime = new Date();
        const playSequencerPromise = forcePlay? SequencerRendererHelper.getInstance().renderAndPlay(this, nodeToPlayFrom, this._masterProcessingTurnedOn, stopAfterMilliseconds, nodeToStopPlayAt, null, window.chrome && EDIT_VIDEO_FILES? this.getActiveVideoRenderer(): null, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible): SequencerRendererHelper.getInstance().playPause(this, nodeToPlayFrom, this._masterProcessingTurnedOn, stopAfterMilliseconds, nodeToStopPlayAt, null, window.chrome && EDIT_VIDEO_FILES? this.getActiveVideoRenderer(): null, shouldSequencerNodeBePlayedValidatorFunction, includeDeletedSegmentsWhenPossible);
        return playSequencerPromise.then((function(){
            //Utils.getInstance().showTrebbleReadyNotification("It took "+((new Date().getTime() - startTime.getTime())/1000 )+"seconds to generate the audio")
        }).bind(this));
        
    },
    
    setAndLoadProject: function(projectId, duplicateProject, progressReportFunction){
        return this.loadProject(projectId, null, null, true, duplicateProject, true, progressReportFunction);
    },

    rerenderAndPlayIfApplicable :function(){
        if(SequencerRendererHelper.getInstance().isPlaying(this) || this._rerenderAndPlayInProgressPromise){
            if(!this._rerenderAndPlayInProgressPromise){
                this._rerenderAndPlayInProgressPromise  = RSVP.Promise.resolve();
                this._playbackProgressInMillisecondsBeforePausing = this.getPlaybackProgressInMilliseconds();
            }
            this._rerenderAndPlayInProgressPromise = this._rerenderAndPlayInProgressPromise.then((function(){
                if(SequencerRendererHelper.getInstance().isPlaying(this)){
                    return SequencerRendererHelper.getInstance().stopPlayingLatestRenderedBuffer(this);
                }
            }).bind(this)).then((function(){
                return this.playSequencerRenderingFromPositionInMilliseconds(this._playbackProgressInMillisecondsBeforePausing);
            }).bind(this)).then((function(result){
                this._rerenderAndPlayInProgressPromise = null;
                return result;
            }).bind(this));
            return this._rerenderAndPlayInProgressPromise;
        }else{
            return RSVP.Promise.resolve();
        }
    },

    closeAudioContext : async function(){
        return await this.getAudioBufferCache().closeAudioContext();
    },

    clearSequencer :function(clearBlobCache){
        const promises = [];
        this.getAudioBufferCache().unloadAllUrlsUsedBySequencer(this, clearBlobCache);
        if(this._transcribedAudioFiles && this._transcribedAudioFiles.length > 0){
            for(let i =0; i < this._transcribedAudioFiles.length; i++){
                const transcribeAudioFileInfo = this._transcribedAudioFiles[i];
                SequencerLibrary.getInstance().clearCachedTranscribeAudio(transcribeAudioFileInfo.audioFileUrl)
                promises.push(this.getAudioBufferCache().unloadAudioBufferFromUrl(transcribeAudioFileInfo.audioFileUrl, transcribeAudioFileInfo.audioFileUrl, AudioBufferHelper.getInstance().getAudioTypes().VOICE));
            }
        }

        this.getHistoryManagement().clear();
        this.getSequencerClipboard().clear();
        this.getSequencerSettings().clear();

        
        
        this._collection.reset();
        this._firstNode = null;
        this._lastNode = null;
        this._cidToSegmentNodeMap = {};
        this._warnedUserForFirstNoiseCancellation = false;
        this._warnedUserForFirstMagicSoundEnhancer = false;
        this._analyzeAllMediaForSilencesPromise = null;
        this._analyzeAllMediaForSilencesHasProgressFunction = false;
        this._workspaceId = undefined;
        // Reset transcript-related registries so a subsequent project does not
        // inherit stale transcription ids, media urls, or speaker state from
        // the previous one. These were previously left alive and could leak
        // across projects.
        this._transcribedAudioFiles = [];
        this._transcribeAudioArray = [];
        this._additionalSpeakerInfoArray = [];
        this.trigger("sequencerBeingCleared", this);

        return RSVP.Promise.all(promises);
    },

    isSequencerPossiblyCleared : function(){
        return !this.getFirstNode() || !this.getLastNode() || !this._cidToSegmentNodeMap || Object.keys(this._cidToSegmentNodeMap).length === 0;
    },

    getSerializedData : function(){
        if(this.getFirstNode()){
            const jsonState = {};
            jsonState.authorId = LocalStorageHelper.getInstance().getLoggedInUserID();
            const cidToCloneSequencerNodes = {};
            const clonedCidToOriginalCid = {};
            let cloneFirstNode = null;
            if(SAVE_PROJECT_WITHOUT_CLONING_NODES){ 
                SequencerNodeUtils.getInstance().getSequencerNodeCidToSequencerNodeMap(this.getFirstNode(),this.getLastNode(), cidToCloneSequencerNodes);
                cloneFirstNode = this.getFirstNode();
            }else{
                cloneFirstNode = SequencerNodeCloner.getInstance().cloneLinkedSequencerNodes(this.getFirstNode(),this.getLastNode(), cidToCloneSequencerNodes);
            }
            const cloneCidToSequencerNodeSerializedData = {};
            const trebbleAudioIdAndTypeToAudioFiledata = {};
            const audioFilesDataArray = []
            for(let cid in cidToCloneSequencerNodes){
                const cloneSequencerNode = cidToCloneSequencerNodes[cid];
                clonedCidToOriginalCid[cloneSequencerNode.cid] = cid;
                const sequencerNodeSerializedData = cloneSequencerNode.getSerializedData();
                delete sequencerNodeSerializedData.sequencer;
                sequencerNodeSerializedData.addToSequencer = false;
                cloneCidToSequencerNodeSerializedData[sequencerNodeSerializedData._cid] = sequencerNodeSerializedData;
                if(cloneSequencerNode.getAudio && cloneSequencerNode.getAudio()){
                    const audioIdAndType = cloneSequencerNode.getAudio().getAudioType()+ ":"+cloneSequencerNode.getAudio().getAudioId();
                    if(!trebbleAudioIdAndTypeToAudioFiledata[audioIdAndType]){
                        const audioSerialiazedData = cloneSequencerNode.getAudio().toJSON();
                        trebbleAudioIdAndTypeToAudioFiledata[audioIdAndType]  = audioSerialiazedData;
                        audioFilesDataArray.push(audioSerialiazedData);
                    }

                }
            }

            jsonState.firstNodeCid = cloneFirstNode.cid;
            jsonState.cloneCidToSequencerNodeSerializedData = cloneCidToSequencerNodeSerializedData;
            jsonState.clonedCidToOriginalCid = clonedCidToOriginalCid;
            jsonState.sequencerSettings  = this._sequencerSettings.getSerializedData();
            jsonState.transcribedAudioFiles = this._transcribedAudioFiles;
            jsonState.otherTrebbleAudioFiles = audioFilesDataArray;
            jsonState.textTranscription = this.getSelectedNodesTextContent(this.getFirstNode(), this.getLastNode(), true);
            jsonState.additionalSpeakerInfoArray = this._additionalSpeakerInfoArray.map((speakerInfo)=>{return speakerInfo.getSerializedData()});
            return jsonState;
        }
    },

    getSelectedNodesTextContent: function(startNode, endNode, includeSpeaker){
        let textContent = "";
        if(!startNode && !endNode){
            startNode =  this.getFirstNode();
            endNode =  this.getLastNode();
        }
        let sequencerNode = startNode;
        let currentSpeakerLabel = null;
        const UNKNOWN_SPEAKER_LABEL  = "Unknown";
        while(sequencerNode){
            if(Utils.getInstance().isWordSequencerNodeInstance(sequencerNode)){
                if(includeSpeaker && currentSpeakerLabel !== sequencerNode.getAudioSegment().getSpeakerLabel()){
                    currentSpeakerLabel = sequencerNode.getAudioSegment().getSpeakerLabel() || UNKNOWN_SPEAKER_LABEL;
                    textContent += "\n\n"+currentSpeakerLabel+": ";
                }
                if(textContent === ""){
                    textContent = sequencerNode.getAudioSegment().getContent();
                }else{
                    textContent =  textContent + " " + sequencerNode.getAudioSegment().getContent();
                }

            }
            if(sequencerNode === endNode){
                sequencerNode = null;
            }else{
                sequencerNode =  sequencerNode.getNextVisibleSequencerNode();
            }
        }
        return textContent;
    },

    getJSONDescriptionForAIAnalysis : function(startNode, endNode, includeSpeaker){
        const nodeJsonDescriptionArray = [];
        if(!startNode && !endNode){
            startNode =  this.getFirstNode();
            endNode =  this.getLastNode();
        }
        let sequencerNode = startNode;
        let currentSpeakerLabel = null;
        const UNKNOWN_SPEAKER_LABEL  = "Unknown";
        while(sequencerNode){
            const nodeJsonDescription = sequencerNode.getJSONDescriptionForAIAnalysis();
            if(nodeJsonDescription){
                nodeJsonDescriptionArray.push(nodeJsonDescription);
            }
            if(sequencerNode === endNode){
                sequencerNode = null;
            }else{
                sequencerNode =  sequencerNode.getNextVisibleSequencerNode();
            }
        }
        return nodeJsonDescriptionArray;
    },

    /**
     * Export sequencer timeline as EDL (Edit Decision List) format
     * 
     * @param {SequencerNode} startNode - Start node (null for beginning)
     * @param {SequencerNode} endNode - End node (null for end)
     * @param {Object} options - Export options
     * @returns {Promise<String>} EDL content as text
     */
    exportEDL: async function(startNode, endNode, options) {
        try {
            // Use the export helper to extract timeline data and generate EDL
            const exportHelper = SequencerExportHelper.getInstance();
            const timelineData = await exportHelper.extractTimelineData(this, startNode, endNode, options);
            return exportHelper.exportEDL(timelineData, options);
        } catch (error) {
            console.error('Error exporting EDL:', error);
            throw new Error('Failed to export EDL: ' + error.message);
        }
    },

    /**
     * Export sequencer timeline as FCPXML (Final Cut Pro XML) format
     * 
     * @param {SequencerNode} startNode - Start node (null for beginning)
     * @param {SequencerNode} endNode - End node (null for end)
     * @param {Object} options - Export options
     * @returns {Promise<String>} FCPXML content as XML
     */
    exportFCPXML: async function(startNode, endNode, options) {
        try {
            // Use the export helper to extract timeline data and generate FCPXML
            const exportHelper = SequencerExportHelper.getInstance();
            const timelineData = await exportHelper.extractTimelineData(this, startNode, endNode, options);
            return exportHelper.exportFCPXML(timelineData, options);
        } catch (error) {
            console.error('Error exporting FCPXML:', error);
            throw new Error('Failed to export FCPXML: ' + error.message);
        }
    },

    /**
     * Download EDL export as file
     * 
     * @param {SequencerNode} startNode - Start node (null for beginning)
     * @param {SequencerNode} endNode - End node (null for end)
     * @param {Object} options - Export options with filename
     */
    downloadEDL: async function(startNode, endNode, options) {
        const exportHelper = SequencerExportHelper.getInstance();
        const edlContent = await this.exportEDL(startNode, endNode, options);
        const filename = (options && options.filename) || 'trebble_project.edl';
        exportHelper.downloadFile(edlContent, filename, 'text/plain');
        
        // Track content export for SaaS tracking
        try {
            FacebookEventTrackingHelper.getInstance().trackAdvancedFeatureUsed('timeline_export_edl');
        } catch(trackingError) {
            console.warn('Failed to track EDL export:', trackingError);
        }
    },

    /**
     * Download FCPXML export as file
     * 
     * @param {SequencerNode} startNode - Start node (null for beginning)  
     * @param {SequencerNode} endNode - End node (null for end)
     * @param {Object} options - Export options with filename
     */
    downloadFCPXML: async function(startNode, endNode, options) {
        const exportHelper = SequencerExportHelper.getInstance();
        const fcpxmlContent = await this.exportFCPXML(startNode, endNode, options);
        const filename = (options && options.filename) || 'trebble_project.fcpxml';
        exportHelper.downloadFile(fcpxmlContent, filename, 'application/xml');
        
        // Track content export for SaaS tracking
        try {
            FacebookEventTrackingHelper.getInstance().trackAdvancedFeatureUsed('timeline_export_fcpxml');
        } catch(trackingError) {
            console.warn('Failed to track FCPXML export:', trackingError);
        }
    },

    setProjectId : function(projectId){
        const oldProjectId = this._projectId;
        this._projectId = projectId;
        if(oldProjectId !== projectId){
            this.trigger("projectIdChange",this._projectId);
            
        }
    },

    setVersionedProjectId : function(versionedProjectId){
        const oldVersionedProjectId = this._versionedProjectId;
        this._versionedProjectId = versionedProjectId;
        if(oldVersionedProjectId !== versionedProjectId){
            this.trigger("versionedProjectIdChange",this._versionedProjectId);
        }
    },

    getVersionedProjectId : function(){
        return this._versionedProjectId;
    },

    getProjectId : function(){
        return this._projectId;
    },

    setWorkspaceId : function(workspaceId){
        this._workspaceId = workspaceId;
    },

    getWorkspaceId : function(){
        return this._workspaceId;
    },

    stopPlaybackIfApplicable : function(){
        if(SequencerRendererHelper.getInstance().isPlaying(this)){
            this._playbackProgressInMillisecondsBeforePausing = this.getPlaybackProgressInMilliseconds();
            return SequencerRendererHelper.getInstance().stopPlayingLatestRenderedBuffer(this);
        }	
    },
    _fetchSectionsMatchingQuery : async function(searchParams, mediaTranscription){

        
            const params = {
                "llmProvider":"anthropic",
                "llmModel":"claude-3-5-sonnet-20240620",
                "searchQuery": searchParams,
                "mediaTranscription": mediaTranscription,
                "llmPromptVersion":"recursive_prompt_with_chunked_input_with_word_ids"
            }
            const urlToQuery = "https://i6moubo23qefrvnu5wodvs7gt40wnuyu.lambda-url.us-east-1.on.aws/";
            const response = await fetch(urlToQuery, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });
           return  await response.json();
    },

    getVerbatimTranscriptionWithIds : function(){
        return Utils.getInstance().getVerbatimTranscriptionWithIds(this.getFirstNode(), null);
    },



    showAIEditSuggestions : async function(aiSuggestionsUrl, projectIdReferenceForSuggestions, aiSuggestionsPrefetched){
        // Fetch AI suggestions data
        const aiSuggestionsData = aiSuggestionsPrefetched ?
            aiSuggestionsPrefetched :
            await Utils.getInstance().fetchJson(aiSuggestionsUrl);

        // If additions haven't been populated yet, check the fetched JSON itself.
        // The S3 result file may contain additionSuggestions when the addition pipeline
        // ran before this fetch (the separate getSuggestionResultUrlForRequestId call
        // returns a plain URL string so additionSuggestions can't be read from it directly).
        const fetchedAdditionSuggestions = aiSuggestionsData && aiSuggestionsData.additionSuggestions;
        const fetchedAdditionSuggestionsArray = Array.isArray(fetchedAdditionSuggestions) ? fetchedAdditionSuggestions :
            (fetchedAdditionSuggestions && Array.isArray(fetchedAdditionSuggestions.additionSuggestions) ? fetchedAdditionSuggestions.additionSuggestions : null);
        if (!this._additionSuggestions && fetchedAdditionSuggestionsArray && fetchedAdditionSuggestionsArray.length > 0) {
            this._additionSuggestions = fetchedAdditionSuggestionsArray;
        }

        // Prepare configuration options
        const options = {
            allowedConfidence: Utils.getInstance().getDefaultAllowedConfidenceLevelArray(),
            allowedTypes: Utils.getInstance().getDefaultAllowedSetOfAISearchQueryPresets(),
            allowedValidationLevels: Utils.getInstance().getDefaultAllowedValidationLevelArray(),
            projectIdReferenceForSuggestions,
            strictMode: true,
            additionSuggestions: this._additionSuggestions || []
        };

        // Prepare callback functions that need Sequencer context
        const callbacks = {
            getSequencerNodeByNodeCid: (id) => this.getSequencerNodeByNodeCid(id),
            getSequencerNodeFromProject: (id, projectId) => SequencerNodeFactory.getInstance().getSequencerNodeUsingNodeCidFromProject(id, projectId, this),
            getSequencerNodeIndex: (node) => this._collection.indexOf(node),
            sequencerInstance: this
        };

        // Use the processor to handle the complex logic
        const result = AIEditSuggestionsProcessor.processAIEditSuggestions(aiSuggestionsData, options, callbacks);
        const isEditLikeMeMode = aiSuggestionsData?.initialRequest?.isEditLikeMeMode === true ||
            aiSuggestionsData?.initialRequest?.isEditLikeMeMode === "true" ||
            !!aiSuggestionsData?.initialRequest?.referenceProjectId;
        return {
            ...result,
            isEditLikeMeMode,
            referenceProjectId: aiSuggestionsData?.initialRequest?.referenceProjectId
        };
    },


    startRequestForAIEditSuggestions : async function(force, searchQueryPresetsArray, preprocessedDeepCutAnalysisResults, isEditLikeMeMode, referenceProjectId){
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            return null;
        }
        const mediaTranscription = this.getVerbatimTranscriptionWithIds();
        if(!mediaTranscription || !mediaTranscription.trim()){
            window.alertUserErrorMessage(window.getI18n(ti18n, "NO_WORDS_TO_ANALYZE_WITH_AI"));
            return null;
        }
        const numberOfTokens = encode(mediaTranscription).length;
        const searchQuery = searchQueryPresetsArray? searchQueryPresetsArray: Utils.getInstance().getDefaultSetOfAISearchQueryPresets();
        let currentProjectId = this.getProjectId() || this.getLoadedProjectId() ;
        const {presignedUrl: presignedUrlForMediaTranscriptionUpload, fileLocationUrl: fileLocationOfMediaTranscription} = await TrebbleClientAPIHelper.getInstance().getPresignedUrlForUploadingSearchOnMediaTranscriptionInputData(currentProjectId? null: this.getFirstTranscriptionId(), currentProjectId ) ;
        
        // Prepare upload data with optional DeepCut analysis results
        const uploadData = {
            transcriptionWithId: mediaTranscription, 
            numberOfTokens
        };
        
        // Include DeepCut analysis results if available
        if (preprocessedDeepCutAnalysisResults) {
            uploadData.preprocessedDeepCutAnalysisResults = preprocessedDeepCutAnalysisResults;
        }
        
        await FileUploadHelper.getInstance().uploadJSONToS3UsignPreSignedUrl(uploadData, presignedUrlForMediaTranscriptionUpload);
        const llmProvider = Utils.getInstance().getDefaultSearchLLMProvider();
        //if(!currentProjectId){
        await this.saveProject(true, "startRequestForAIEditSuggestions",  "start request for ai suggestions");
        //}
        const projectIdSaved = this.getVersionedProjectId() || this.getProjectId() || this.getLoadedProjectId();
        const startAIEditSuggestionRequest = await TrebbleClientAPIHelper.getInstance().startAISearchOnMediaTranscription(this.getFirstTranscriptionId(), projectIdSaved, fileLocationOfMediaTranscription, searchQuery, numberOfTokens, this.getHasVideoSegment(), this.getFirstLanguageCodeUsed(), llmProvider, preprocessedDeepCutAnalysisResults, force, isEditLikeMeMode, referenceProjectId);
        await this.getAudioBufferCache().addSequencerToBeNotifiedOnAISuggestionRequestCompletes(this, projectIdSaved, this.getFirstTranscriptionId());
        //await this.saveProject(true, "requestForAIEditSuggestionsCreaeted",  "request for ai suggestions created", true);
        return startAIEditSuggestionRequest;
    },

    closeSearchPanel: function(){
        this.getSearchWidget().clearSearch();
        this.trigger("closeSearchPanel");
    },

    // Configuration constant to control DeepCut wizard integration
    _shouldShowDeepCutWizardBeforeAIAnalysis: function() {
        return true;
        // This can be controlled via feature flags, user preferences, or environment variables
        // Priority order: explicit sequencer setting > global config > default enabled
        if (this._deepCutWizardEnabled !== undefined) {
            return this._deepCutWizardEnabled;
        }
        if (window.trebble && window.trebble.config && window.trebble.config.enableDeepCutWizard !== undefined) {
            return window.trebble.config.enableDeepCutWizard;
        }
        // Default to enabled - you can change this to false to disable by default
        return true;
    },

    // Public method to enable/disable DeepCut wizard for this sequencer instance
    setDeepCutWizardEnabled: function(enabled) {
        this._deepCutWizardEnabled = enabled;
    },

    // Public method to check if DeepCut wizard is enabled
    isDeepCutWizardEnabled: function() {
        return this._shouldShowDeepCutWizardBeforeAIAnalysis();
    },

    // One-line DeepCut analysis that returns full analysis results or null
    displayAIEditSuggestionsInEditLikeMeMode: function(force) {
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            return false;
        }
        // Same as displayAIEditSuggestions but opens the wizard in Edit Like Me mode
        const transcriptText = this.getSelectedNodesTextContent(this.getFirstNode(), this.getLastNode(), true);
        if (!transcriptText || transcriptText.trim().length === 0) {
            window.alertErrorMessage("No transcript available to analyze.");
            return;
        }
        const transcriptId = this.getFirstTranscriptionId();
        const projectId = this.getProjectId() || this.getLoadedProjectId();
        const onEditingPlanApplied = async (editingPlan) => {
            // Convert editing plan to searchQueryPresetsArray format
            const searchPresets = [];
            // Support both legacy selectedChips and new chipUpdates/plan formats
            const chips = editingPlan?.selectedChips || editingPlan?.chipUpdates || editingPlan?.plan || [];
            if (chips.length > 0) {
                chips.forEach(chip => {
                    const chipType = chip.type || chip.chipLabel;
                    const presetMap = {
                        'REMOVE_FILLER_WORDS': 'REMOVE_FILLER_WORDS',
                        'TRIM_SILENCES': 'TRIM_LONG_PAUSES',
                        'REMOVE_REPETITION': 'REMOVE_REPETITIVE_CONTENT',
                        'IMPROVE_FLOW': 'IMPROVE_NARRATIVE_FLOW',
                        'REMOVE_OFF_TOPIC': 'REMOVE_OFF_TOPIC_CONTENT',
                        'ENHANCE_CLARITY': 'ENHANCE_CLARITY'
                    };
                    const presetName = presetMap[chipType] || chipType;
                    if (presetName) searchPresets.push(presetName);
                });
            }
            const finalSearchQueryPresetsArray = searchPresets.length > 0 ? searchPresets : Utils.getInstance().getDefaultSetOfAISearchQueryPresets();

            // Show loading feedback while the request is being prepared
            const notifId = new Date().getTime().toString();
            TrebbleNotificationManager.createLoadingNotification(notifId, null, window.getI18n(ti18n, "ELM_PREPARING_CONTENT_FOR_REVIEW"), { duration: 0, darkTheme: false, placement: "topRight" });

            try {
                const startRequestResult = await this.startRequestForAIEditSuggestions(!!force, finalSearchQueryPresetsArray, editingPlan, editingPlan.isEditLikeMeMode, editingPlan.referenceProjectId);
                TrebbleNotificationManager.destroyNotification(notifId);
                if(!startRequestResult){
                    return;
                }
                // Show confirmation with fun GIF — uses ELM-specific strings (not DeepCut™)
                const customImages = ["working1.gif", "working2.gif", "working3.gif", "working4.gif", "working5.gif", "working6.gif"];
                const buttonLabels = [window.getI18n(ti18n, "OK")];
                Utils.getInstance().showConfirmDialogWithRandomImage(
                    window.getI18n(ti18n, "ELM_REVIEWING_CONTENT_ENHANCED_TITLE"),
                    window.getI18n(ti18n, "ELM_REVIEWING_CONTENT_ENHANCED_SUBTITLE"),
                    customImages,
                    buttonLabels
                );
            } catch (err) {
                TrebbleNotificationManager.destroyNotification(notifId);
                console.error('Failed to start ELM request:', err);
            }
        };
        PersistentModels.getInstance().getRouter().showDeepCutAnalysisPopup(
            transcriptText, transcriptId, projectId, null, onEditingPlanApplied, true /* isEditLikeMeMode */
        );
    },

    getDeepCutEnhancedSearchPresets: function() {
        if(typeof this.hasMutationAccess === "function" && !this.hasMutationAccess()){
            return Promise.resolve(null);
        }
        return new Promise((resolve) => {
            try {
                // Quick check if DeepCut should be shown
                if (!this.isDeepCutWizardEnabled()) {
                    resolve(null);
                    return;
                }

                const transcriptText = this.getSelectedNodesTextContent(this.getFirstNode(), this.getLastNode(), true);
                if (!transcriptText || transcriptText.trim().length === 0) {
                    resolve(null);
                    return;
                }

                const transcriptId = this.getFirstTranscriptionId();
                const projectId = this.getProjectId() || this.getLoadedProjectId();

                const onEditingPlanApplied = (editingPlan) => {
                    // Convert editing plan to searchQueryPresetsArray format
                    const searchPresets = [];
                    if (editingPlan && editingPlan.selectedChips) {
                        editingPlan.selectedChips.forEach(chip => {
                            const presetMap = {
                                'REMOVE_FILLER_WORDS': 'REMOVE_FILLER_WORDS',
                                'TRIM_SILENCES': 'TRIM_LONG_PAUSES',
                                'REMOVE_REPETITION': 'REMOVE_REPETITIVE_CONTENT',
                                'IMPROVE_FLOW': 'IMPROVE_NARRATIVE_FLOW',
                                'REMOVE_OFF_TOPIC': 'REMOVE_OFF_TOPIC_CONTENT',
                                'ENHANCE_CLARITY': 'ENHANCE_CLARITY'
                            };
                            const presetName = presetMap[chip.type] || chip.type;
                            searchPresets.push(presetName);
                        });
                    }
                    
                    // Return full analysis results for startRequestForAIEditSuggestions
                    resolve({
                        searchQueryPresetsArray: searchPresets.length > 0 ? searchPresets : Utils.getInstance().getDefaultSetOfAISearchQueryPresets(),
                        preprocessedDeepCutAnalysisResults: editingPlan
                    });
                };

                const onAnalysisComplete = () => resolve(null);
                const onWizardClosed = () => resolve(null);

                PersistentModels.getInstance().getRouter().showDeepCutAnalysisPopup(transcriptText, transcriptId, projectId, onAnalysisComplete, onEditingPlanApplied);
                
            } catch (error) {
                console.error("Error in DeepCut analysis:", error);
                resolve(null);
            }
        });
    },

    findSemanticTextSearchResult : async function(searchParams, force, prefetchedAISuggestionResultUrl, requestId, cachedAISuggestions){
        // Clear stale addition suggestions ONLY when this is a fresh (non-ELM) search.
        // When called via the ELM path (displayAIEditSuggestionsByRequestId), _additionSuggestions
        // was already set before this call and must be preserved.
        if (!prefetchedAISuggestionResultUrl) {
            this._additionSuggestions = null;
        }
        let notificationProgressUniqueId = new Date().getTime().toString();
        let sequencerNodeIdsToGroup  = null;
        let aiSuggestions = null;
        let pendingRequest = false;
        let doNotShowNotitfication =  !!cachedAISuggestions;
        if(!doNotShowNotitfication){
            TrebbleNotificationManager.createLoadingNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "TAKING_LOOK_AT_CONTENT"),{ duration: 0 ,darkTheme: false,  placement:"topRight"});
        }
        try{
            const strictMatch =  true;
            const projectId = this.getProjectId() || this.getLoadedProjectId();
            let {resultFileUrl:aiEditSuggestionsUrl,alreadyPendingRequest, requestResultId} = !force && !prefetchedAISuggestionResultUrl && !cachedAISuggestions? await TrebbleClientAPIHelper.getInstance().getAIEditsForMediaTranscription(this.getFirstTranscriptionId(), projectId, searchParams.searchQueryPresetsArray, strictMatch): {resultFileUrl: prefetchedAISuggestionResultUrl, requestResultId: requestId};
            requestId = requestResultId;
            if(!aiEditSuggestionsUrl && !force){
                aiEditSuggestionsUrl = this._lastLoadedAiEditSuggestionsUrl;
            }else{
                if(aiEditSuggestionsUrl){
                    this._lastLoadedAiEditSuggestionsUrl = aiEditSuggestionsUrl;
                }
            }
            if(aiEditSuggestionsUrl){
                // Fetch addition suggestions if we have a requestId and don't already have them.
                // The addition detector runs after the deletion pipeline, so additions may not
                // be ready yet — retry once after a delay if needed.
                if (requestId && !this._additionSuggestions) {
                    try {
                        var addResult = await TrebbleClientAPIHelper.getInstance().getSuggestionResultUrlForRequestId(requestId);
                        var additions = (addResult && typeof addResult === 'object') ? addResult.additionSuggestions : null;
                        additions = Array.isArray(additions) ? additions :
                            (additions && Array.isArray(additions.additionSuggestions) ? additions.additionSuggestions : null);
                        if (!additions) {
                            await new Promise(function(r) { setTimeout(r, 8000); });
                            addResult = await TrebbleClientAPIHelper.getInstance().getSuggestionResultUrlForRequestId(requestId);
                            additions = (addResult && typeof addResult === 'object') ? addResult.additionSuggestions : null;
                            additions = Array.isArray(additions) ? additions :
                                (additions && Array.isArray(additions.additionSuggestions) ? additions.additionSuggestions : null);
                        }
                        if (additions && Array.isArray(additions) && additions.length > 0) {
                            this._additionSuggestions = additions;
                        }
                    } catch (addErr) {
                    }
                }
                const result = await this.showAIEditSuggestions(aiEditSuggestionsUrl, projectId, cachedAISuggestions);
                sequencerNodeIdsToGroup = result.sequencerNodeIdsToGroup;
                aiSuggestions = result.aiSuggestions;
                const isEditLikeMeMode = result.isEditLikeMeMode;
                const referenceProjectId = result.referenceProjectId;
                if(!doNotShowNotitfication){
                    TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                    if (sequencerNodeIdsToGroup && Object.keys(sequencerNodeIdsToGroup).length > 0) {
                        if(this._aiEditSuggestionsUrlForWhichCelebrationNotificationWasShown.indexOf(aiEditSuggestionsUrl) === -1){
                            this._aiEditSuggestionsUrlForWhichCelebrationNotificationWasShown.push(aiEditSuggestionsUrl);
                            const customImages = ["celebration1.gif","celebration2.gif","celebration3.gif","celebration4.gif","celebration5.gif","celebration6.gif","celebration7.gif","celebration8.gif","celebration9.gif","celebration10.gif","celebration11.gif","celebration12.gif"];
                            const buttonLabels = [window.getI18n(ti18n, "OK")];
                            Utils.getInstance().showConfirmDialogWithRandomImage(window.getI18n(ti18n, "FOUND_SUGGESTIONS_TO_IMPROVE"), "", customImages, buttonLabels)
                        }else{
                            TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "FOUND_SUGGESTIONS_TO_IMPROVE"), {duration: 5, darkTheme: false, placement:"topRight" })
                        }
                    } else {
                        TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "CONTENT_ALREADY_IN_GREAT_SHAPE"), {duration: 5, darkTheme: false, placement:"topRight" })
                    }
                }
                return {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions, isEditLikeMeMode, referenceProjectId, aiSuggestionsResultUrl: prefetchedAISuggestionResultUrl? prefetchedAISuggestionResultUrl: aiEditSuggestionsUrl};
            }else{
                if(alreadyPendingRequest){
                    pendingRequest = true;
                    if(!doNotShowNotitfication){
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                        TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "STILL_REVIEWING_CONTENT"), {duration: 5, darkTheme: false, placement:"topRight" })
                    }
                    return {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions};
                }else{
                    // Use DeepCut to enhance search presets if enabled
                    let notificationHidden = false;
                    if(this.isDeepCutWizardEnabled()){
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                        notificationHidden = true;
                    }
                    const deepCutResults = await this.getDeepCutEnhancedSearchPresets();
                    const finalSearchQueryPresetsArray = deepCutResults ? deepCutResults.searchQueryPresetsArray : searchParams.searchQueryPresetsArray;
                    const preprocessedDeepCutAnalysisResults = deepCutResults ? deepCutResults.preprocessedDeepCutAnalysisResults : null;
                    
                    // Start the AI edit suggestions request
                    if(notificationHidden){
                        TrebbleNotificationManager.createLoadingNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "PREPARING_CONTENT_FOR_REVIEW"),{ duration: 0 ,darkTheme: false,  placement:"topRight"});
                    }
                    const startRequestResult = await this.startRequestForAIEditSuggestions(force, finalSearchQueryPresetsArray, preprocessedDeepCutAnalysisResults);
                    if(!startRequestResult){
                        // startRequestForAIEditSuggestions returned null after targeted
                        // feedback, or as a silent access-denied no-op. Avoid generic
                        // success/hiccup feedback.
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                        return {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions};
                    }
                    requestId = startRequestResult.aiEditSuggestionsOnMediaTranscriptionRequestId;
                    pendingRequest = true;

                    if(!doNotShowNotitfication){
                        TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                        //TrebbleNotificationManager.createSuccessNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "REVIEWING_CONTENT_WILL_NOTIFY"), {duration: 5, darkTheme: false, placement:"topRight" })
                        const customImages = ["working1.gif","working2.gif","working3.gif","working4.gif","working5.gif","working6.gif"];
                        const buttonLabels = [window.getI18n(ti18n, "OK")];
                        Utils.getInstance().showConfirmDialogWithRandomImage(
                            window.getI18n(ti18n, "REVIEWING_CONTENT_ENHANCED_TITLE"),
                            window.getI18n(ti18n, "REVIEWING_CONTENT_ENHANCED_SUBTITLE"),
                            customImages,
                            buttonLabels
                        )
                    }

                    return {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions};
                }
            }
        }catch(e){
            console.error(e);
            if(!doNotShowNotitfication){
                TrebbleNotificationManager.destroyNotification(notificationProgressUniqueId);
                TrebbleNotificationManager.createErrorNotification(notificationProgressUniqueId, null, window.getI18n(ti18n, "SMALL_HICCUP_ERROR"), {duration: 5, darkTheme: false, placement:"topRight" })
            }
            return {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions};
        }
    },

    playPauseSequencerRendering : function(){
        this.getAudioBufferCache().resumeAudiContextToKeepHeartbeat();
        if(SequencerRendererHelper.getInstance().isPlaying(this)){
            return this.stopPlaybackIfApplicable();
        }else{
            return this.playSequencerRenderingFromPositionInMilliseconds(this._playbackProgressInMillisecondsBeforePausing);
        }
    },

    stopPlayingSequencerRenderingAndSuspendAudioContextForStalledPlayback: function(){
        this.getAudioBufferCache().suspendAudioContextInStalledPlayback();
        return SequencerRendererHelper.getInstance().stopPlayingLatestRenderedBuffer(this);
    },

    restartPlayingSequencerRenderingAndSuspendAudioContextForStalledPlayback: function(){
        const playbackProgressInMilliseconds = this.getPlaybackProgressInMilliseconds();
        this.getAudioBufferCache().suspendAudioContextInStalledPlayback();
        return SequencerRendererHelper.getInstance().stopPlayingLatestRenderedBuffer(this).then((function(){
            this.playSequencerRenderingFromPositionInMilliseconds(playbackProgressInMilliseconds);
        }).bind(this));
    },

    playSequencerRenderingFromPositionInMilliseconds: function(timeInMilliseconds){
        this.getAudioBufferCache().resumeAudiContextToKeepHeartbeat();
        this._playbackProgressInMillisecondsBeforePausing = timeInMilliseconds;
        const startTime = new Date();
        return SequencerRendererHelper.getInstance().playFromTimeInMilliseconds(this, timeInMilliseconds, this._masterProcessingTurnedOn, null, window.chrome && EDIT_VIDEO_FILES? this.getActiveVideoRenderer(): null).then((function(){
            //Utils.getInstance().showTrebbleReadyNotification("It took "+((new Date().getTime() - startTime.getTime())/1000 )+"seconds to generate the audio")
        }).bind(this));
    },

    getSearchWidget : function(){
        return this._sequencerSearchWidget;
    },

    setSearchOn: function(searchOn){
        this._sequencerSearchWidget.setSearchOn(searchOn);
        this.setRerenderOnNextPlayback(true);
    },

    isInSearchMode : function(searchOn){
        return this._sequencerSearchWidget.isSearchOn();
    },

    applyTextSearch : async function(searchKeyword){
        const result = await this._sequencerSearchWidget.applyTextSearch(searchKeyword);
        if(result !== null){ // Only proceed if operation wasn't cancelled
            this.setSearchOn(true);
        }
    },

    setPlaybackOn : function(playbackOn){
        this._sequencerSearchWidget.setPlaybackOn(playbackOn);
    },

    clearSearch: function(){
        this._sequencerSearchWidget.clearSearch();
    },

    cancelOngoingSearchOperations: function(){
        this._sequencerSearchWidget.cancelOngoingSearchOperations();
    },

    showNextSequencerNodeFoundInSearch: function(){
        this._sequencerSearchWidget.moveToNextFoundNode();
    },

    showPreviousSequencerNodeFoundInSearch: function(){
        this._sequencerSearchWidget.moveToPreviousFoundNode();
    },

    resetPlaybackPositionOnAudioPlaybackCompleted : function(){
        this._playbackProgressInMillisecondsBeforePausing = 0;
    },

    setRenderedBufferPlaying : function(isPlaying){
        this.set("renderedBufferPlaying", isPlaying)
    },

    setRenderingBeingCreated : function(renderingBeingCreated){
        if(renderingBeingCreated){
            this.setRerenderOnNextPlayback(false);
        }
        this.set("renderingBeingCreated", renderingBeingCreated)
    },

    setRenderedBufferPlaybackLoading : function(renderedBufferPlaybackLoading){
        this.set("renderedBufferPlaybackLoading", renderedBufferPlaybackLoading)
    },

    isRenderingBeingCreated : function(){
        return this.get("renderingBeingCreated");
    },

    isRenderedBufferPlaying : function(){
        return this.get("renderedBufferPlaying")
    },	

    isRenderedBufferPlaybackLoading : function(){
        return this.get("renderedBufferPlaybackLoading")
    },

    getDurationInMilliseconds : function(){
        return SequencerRendererHelper.getInstance().getDuration(this);
    },

    getPlaybackProgressInMilliseconds : function(){
        return SequencerRendererHelper.getInstance().getPlaybackProgress(this);
    },

    getPlaybackAudioContextCurrentTime: function(){
        return SequencerRendererHelper.getInstance().getPlaybackAudioContextCurrentTime(this);
    },

    canPlayThrough: function(){
        return SequencerRendererHelper.getInstance().canPlayThrough(this);
    },

});
window.trebble.globalHelpers.Sequencer = Sequencer;
export default Sequencer;
